export const toursNewYork = [
  {
    tourId: 37483,
    title: 'NYC: Top of the Rock Observation Deck Flexible Date Ticket',
    url: 'https://www.getyourguide.com/new-york-city-l59/top-of-the-rock-observation-deck-t37483/',
    price: {
      original: '€ 38.74',
      min: '€ 38.74',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1531297-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1531297-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1531297-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1531297-53.jpg',
    smallDescription: 'Take in 360-degree panoramic views of the Big Apple from Top of the Rock’s iconic observation deck. From Central Park to the Empire State Building,…',
    description: 'Take in 360-degree panoramic views of the Big Apple from Top of the Rock’s iconic observation deck. From Central Park to the Empire State Building, see it all from up in the air. This flexible date ticket allows you to plan your visit around the weather.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: true,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1531297-68.jpg',
    imageAlt: 'nyc top of the rock observation deck flexible date ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 2361,
    totalRatingTitle: '2361 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 hour',
    validFrom: 'time_booked',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 0,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/top-of-the-rock-observation-deck-t37483/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 39 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 0,
    highlightedOrientation: 'horizontal',
    keyDetails: {
      duration: {
        label: 'Duration:',
        description: '1 hour',
      },
      cancellation_policy: {
        label: 'Easy cancellation',
        description: 'Cancel up to 24 hours in advance for a full refund',
      },
      instant_confirmation: {
        label: 'Instant confirmation',
        description: '',
      },
    },
  },
  {
    tourId: 109024,
    title: 'New York: 9/11 Memorial &amp; Museum Skip-the-Ticket-Line Entry',
    url: 'https://www.getyourguide.com/new-york-city-l59/911-memorial-museum-admission-skip-the-ticket-line-t109024/',
    price: {
      original: '€ 26.22',
      min: '€ 26.22',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-752509-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-752509-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-752509-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-752509-53.jpg',
    smallDescription: 'Reflect on the events of September 11, 2001 when visiting the poignant 9/11 Memorial & Museum. Listen to personal stories of remembrance & resilience…',
    description: 'Reflect on the events of September 11, 2001 when visiting the poignant 9/11 Memorial &amp; Museum. Listen to personal stories of remembrance &amp; resilience following the terrorist attacks. Pre-book tickets for convenient skip-the-ticket-line privileges.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      88,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-752509-68.jpg',
    imageAlt: 'new york 9/11 memorial museum skiptheticketline entry',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 5899,
    totalRatingTitle: '5899 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 1,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/911-memorial-museum-admission-skip-the-ticket-line-t109024/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/27/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 26 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 1,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 6195,
    title: 'NYC: Empire State Building General &amp; Skip-the-Line Tickets',
    url: 'https://www.getyourguide.com/empire-state-building-l2608/skip-the-line-empire-state-building-observatory-tickets-t6195/',
    price: {
      original: '€ 42.83',
      min: '€ 42.83',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3450197-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3450197-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3450197-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3450197-53.jpg',
    smallDescription: 'Ascend to the 86th floor with a flexible date ticket for incredible panoramic views across 6 states from the highest 360 degree open-air vantage…',
    description: 'Ascend to the 86th floor with a flexible date ticket for incredible panoramic views across 6 states from the highest 360 degree open-air vantage point in New York City. Skip all the lines by choosing the Express Ticket Option.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      88,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: true,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3450197-68.jpg',
    imageAlt: 'nyc empire state building general skiptheline tickets',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 5345,
    totalRatingTitle: '5345 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 2,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/empire-state-building-l2608/skip-the-line-empire-state-building-observatory-tickets-t6195/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 43 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 2,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 52132,
    title: 'New York One World Observatory: Skip-the-Line Ticket Options',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-one-world-observatory-entrance-ticket-t52132/',
    price: {
      original: '€ 38.74',
      min: '€ 38.74',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1466314-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1466314-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1466314-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1466314-53.jpg',
    smallDescription: 'Journey to the top of the tallest building in the Western Hemisphere and admire the incredible views over New York. Pre-book tickets and choose to…',
    description: 'Journey to the top of the tallest building in the Western Hemisphere and admire the incredible views over New York. Pre-book tickets and choose to skip just the ticket line or all the lines.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: true,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1466314-68.jpg',
    imageAlt: 'new york one world observatory skiptheline ticket options',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 6318,
    totalRatingTitle: '6318 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 3,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-one-world-observatory-entrance-ticket-t52132/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 39 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 3,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 28502,
    title: 'JFK and La Guardia Airports: Shared Transfer to Manhattan',
    url: 'https://www.getyourguide.com/john-f-kennedy-international-airport-l87708/jfk-lga-and-ewr-shared-transfer-to-new-york-city-t28502/',
    price: {
      original: '€ 18.36',
      min: '€ 18.36',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736753-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736753-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736753-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736753-53.jpg',
    smallDescription: 'Start your trip to New York City with this trouble-free shared airport transfer. Why wait in a long cab line when you can be on your way to your…',
    description: 'Start your trip to New York City with this trouble-free shared airport transfer. Why wait in a long cab line when you can be on your way to your hotel or cruise ship terminal in Manhattan? This safe and reliable transfer saves you time, effort, and money.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-736753-68.jpg',
    imageAlt: 'jfk and la guardia airports shared transfer to manhattan',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.6',
    maxPossibleRating: 5,
    totalRating: 1160,
    totalRatingTitle: '1160 Reviews',
    averageRatingClass: '35',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '35 - 40 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 4,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/john-f-kennedy-international-airport-l87708/jfk-lga-and-ewr-shared-transfer-to-new-york-city-t28502/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Saturday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 18 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 4,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 120169,
    title: 'NYC: Statue of Liberty Priority or Standard Ticket',
    url: 'https://www.getyourguide.com/new-york-city-l59/priority-statue-of-liberty-ticket-with-pedestal-option-t120169/',
    price: {
      original: '€ 23.65',
      min: '€ 23.65',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1737331-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1737331-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1737331-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1737331-53.jpg',
    smallDescription: 'Tour the world-class attractions Statue of Liberty, Ellis Island National Immigration Museum, Statue of Liberty Museum and Ellis Island at your own…',
    description: 'Tour the world-class attractions Statue of Liberty, Ellis Island National Immigration Museum, Statue of Liberty Museum and Ellis Island at your own pace with accompanying audio guides.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      6,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1737331-68.jpg',
    imageAlt: 'nyc statue of liberty priority or standard ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 5134,
    totalRatingTitle: '5134 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 5,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/priority-statue-of-liberty-ticket-with-pedestal-option-t120169/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 24 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 5,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 156438,
    title: 'New York City: Central Park Bicycle Rental',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-bicycle-rental-t156438/',
    price: {
      original: '€ 7.02',
      min: '€ 7.02',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2732958-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2732958-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2732958-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2732958-53.jpg',
    smallDescription: 'Explore New York City on a bike rented from a company conveniently located near Central Park.',
    description: 'Explore New York City on a bike rented from a company conveniently located near Central Park.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2732958-68.jpg',
    imageAlt: 'new york city central park bicycle rental',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 26,
    totalRatingTitle: '26 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours - 1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 6,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-bicycle-rental-t156438/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 7 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 6,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 385987,
    title: 'New York City: Met Museum Online Tour with Guide',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-met-museum-virtual-tour-with-guide-t385987/',
    price: {
      original: '€ 9.37',
      min: '€ 9.37',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3430679-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3430679-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3430679-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3430679-53.jpg',
    smallDescription: 'Join an official Met Museum guide on an online tour of New York City’s Metropolitan Museum of Art. Listen to hilarious stories behind the famous art.',
    description: 'Join an official Met Museum guide on an online tour of New York City’s Metropolitan Museum of Art. Listen to hilarious stories behind the famous art.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3430679-68.jpg',
    imageAlt: 'new york city met museum online tour with guide',
    isFreeCancellation: true,
    hasRating: false,
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 7,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-met-museum-virtual-tour-with-guide-t385987/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Thursday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 9 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 7,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 5721,
    title: 'New York City Explorer Pass w. Over 85 Tours &amp; Attractions',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-explorer-passtm-t5721/',
    price: {
      original: '€ 121.75',
      min: '€ 60.88',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2485632-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2485632-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2485632-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2485632-53.jpg',
    smallDescription: 'The New York City Explorer Pass is the best choice for maximum savings and flexibility. Save up to 55% off admission to over 85 attractions and…',
    description: 'The New York City Explorer Pass is the best choice for maximum savings and flexibility. Save up to 55% off admission to over 85 attractions and iconic landmarks including the Empire State Building.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
      23,
      35,
      39,
      55,
      56,
      88,
    ],
    hasDeal: true,
    dealMaxPercentage: 50,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2485632-68.jpg',
    imageAlt: 'new york city explorer pass w. over 85 tours attractions',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 902,
    totalRatingTitle: '902 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '30 days',
    validFrom: 'time_activated',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 8,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-explorer-passtm-t5721/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 61 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 8,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 25757,
    title: 'American Museum of Natural History Tickets',
    url: 'https://www.getyourguide.com/new-york-city-l59/american-museum-of-natural-history-super-saver-admission-t25757/',
    price: {
      original: '€ 21.54',
      min: '€ 21.54',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-449242-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-449242-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-449242-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-449242-53.jpg',
    smallDescription: 'Visit the American Museum of Natural History, the most interactive natural history museum in the world. Upgrade to a Super Saver ticket to include…',
    description: 'Visit the American Museum of Natural History, the most interactive natural history museum in the world. Upgrade to a Super Saver ticket to include special exhibits, an IMAX Theater Film, and the Hayden Planetarium.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-449242-68.jpg',
    imageAlt: 'american museum of natural history tickets',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 1148,
    totalRatingTitle: '1148 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 9,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/american-museum-of-natural-history-super-saver-admission-t25757/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 22 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 9,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 179501,
    title: 'New York: Madison Square Garden All Access Tour Ticket',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-madison-square-garden-all-access-tour-ticket-t179501/',
    price: {
      original: '€ 32.78',
      min: '€ 32.78',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1534606-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1534606-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1534606-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1534606-53.jpg',
    smallDescription: "Experience Madison Square Garden like never before. On this new behind-the-scenes tour of the world's most famous arena, learn about iconic moments…",
    description: 'Experience Madison Square Garden like never before. On this new behind-the-scenes tour of the world&#039;s most famous arena, learn about iconic moments that have made sports and entertainment history.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1534606-68.jpg',
    imageAlt: 'new york madison square garden all access tour ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 185,
    totalRatingTitle: '185 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '75 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 10,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-madison-square-garden-all-access-tour-ticket-t179501/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 33 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 10,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 239042,
    title: 'New York: Metropolitan Museum of Art Skip-the-Line Ticket',
    url: 'https://www.getyourguide.com/new-york-city-l59/skip-the-line-the-metropolitan-museum-of-art-t239042/',
    price: {
      original: '€ 23.41',
      min: '€ 23.41',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1848142-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1848142-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1848142-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1848142-53.jpg',
    smallDescription: "Skip-the-line at the Metropolitan Museum of Art, one of the world's finest art galleries. 17 curatorial collections feature over 2 million works of…",
    description: 'Skip-the-line at the Metropolitan Museum of Art, one of the world&#039;s finest art galleries. 17 curatorial collections feature over 2 million works of art from ancient Egypt to modern day. Benefit from 3-day admission with one entry to each museum location.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      88,
      93,
      64,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1848142-68.jpg',
    imageAlt: 'new york metropolitan museum of art skiptheline ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 729,
    totalRatingTitle: '729 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 - 3 days',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 11,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/skip-the-line-the-metropolitan-museum-of-art-t239042/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 23 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 11,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 276172,
    title: 'Manhattan: EWR Shared Airport Transfer',
    url: 'https://www.getyourguide.com/new-york-city-l59/manhattan-ewr-shared-airport-transfer-t276172/',
    price: {
      original: '€ 19.67',
      min: '€ 19.67',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2232557-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2232557-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2232557-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2232557-53.jpg',
    smallDescription: 'Start your trip to New York City with this trouble-free shared airport transfer. Why wait in a long cab line when you can be on your way to your…',
    description: 'Start your trip to New York City with this trouble-free shared airport transfer. Why wait in a long cab line when you can be on your way to your hotel or cruise ship terminal in Manhattan? This safe and reliable transfer saves you time, effort, and money.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2232557-68.jpg',
    imageAlt: 'manhattan ewr shared airport transfer',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.4',
    maxPossibleRating: 5,
    totalRating: 175,
    totalRatingTitle: '175 Reviews',
    averageRatingClass: '35',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '40 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 12,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/manhattan-ewr-shared-airport-transfer-t276172/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 20 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 12,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 298110,
    title: 'New York City: West Side Story The Musical Broadway Tickets',
    url: 'https://www.getyourguide.com/broadway-new-york-city-l3362/new-york-city-west-side-story-the-musical-broadway-tickets-t298110/',
    price: {
      original: '€ 45.66',
      min: '€ 45.66',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2460640-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2460640-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2460640-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2460640-53.jpg',
    smallDescription: "Be the first to see the new \"West Side Story.\" Imagine Shakespeare's Romeo and Juliet in the gang-ridden streets of 1950s Manhattan, dominated by the…",
    description: 'Be the first to see the new &quot;West Side Story.&quot; Imagine Shakespeare&#039;s Romeo and Juliet in the gang-ridden streets of 1950s Manhattan, dominated by the Sharks and the Jets. Watch as two teens from enemy gangs meet and fall in love.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2460640-68.jpg',
    imageAlt: 'new york city west side story the musical broadway tickets',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 3,
    totalRatingTitle: '3 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '100 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 13,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/broadway-new-york-city-l3362/new-york-city-west-side-story-the-musical-broadway-tickets-t298110/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 09/08/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 46 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 13,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 69845,
    title: 'Woodbury Common Premium Outlets Shopping Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/woodbury-common-shopping-tour-t69845/',
    price: {
      original: '€ 37.46',
      min: '€ 37.46',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736810-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736810-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736810-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736810-53.jpg',
    smallDescription: 'Get discounts on designer goods at Woodbury Common Premium Outlets in Central Valley, New York. Benefit from round-trip transfers and multiple…',
    description: 'Get discounts on designer goods at Woodbury Common Premium Outlets in Central Valley, New York. Benefit from round-trip transfers and multiple departure times from New York City. Fill your bags with bargain fashion items from over 200 stores.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-736810-68.jpg',
    imageAlt: 'woodbury common premium outlets shopping tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 420,
    totalRatingTitle: '420 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 14,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/woodbury-common-shopping-tour-t69845/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 37 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 14,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 113713,
    title: 'City Lights Experience - Helicopter Tour over NYC by Night',
    url: 'https://www.getyourguide.com/new-york-city-l59/city-lights-experience-night-tour-of-new-york-city-t113713/',
    price: {
      original: '€ 228.52',
      min: '€ 191.04',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-772660-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-772660-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-772660-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-772660-53.jpg',
    smallDescription: "Soar through the New York City skies by Helicopter, taking in the incredible views of the city's skyline lit up and sparkling at night. Amazing views…",
    description: 'Soar through the New York City skies by Helicopter, taking in the incredible views of the city&#039;s skyline lit up and sparkling at night. Amazing views both at sunset and night await you. There is no other experience from the sky like this!&quot;',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: true,
    dealMaxPercentage: 16.400000000000006,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-772660-68.jpg',
    imageAlt: 'city lights experience  helicopter tour over nyc by night',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.9',
    maxPossibleRating: 5,
    totalRating: 29,
    totalRatingTitle: '29 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '25 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 15,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/city-lights-experience-night-tour-of-new-york-city-t113713/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 191 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 15,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 314862,
    title: '60-Minute Cruise Around the Statue of Liberty &amp; Ellis Island',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-lady-liberty-70-minute-sightseeing-cruise-t314862/',
    price: {
      original: '€ 28.10',
      min: '€ 28.10',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2632102-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2632102-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2632102-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2632102-53.jpg',
    smallDescription: "Get up close to one of the world's most famous monuments and the emblematic entrance to New York's harbor. Sail around the Statue of Liberty on a…",
    description: 'Get up close to one of the world&#039;s most famous monuments and the emblematic entrance to New York&#039;s harbor. Sail around the Statue of Liberty on a 60-minute sightseeing cruise that also journeys under the Brooklyn Bridge and over to Ellis Island.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      88,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2632102-68.jpg',
    imageAlt: '60minute cruise around the statue of liberty ellis island',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 1302,
    totalRatingTitle: '1302 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '60 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 16,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-lady-liberty-70-minute-sightseeing-cruise-t314862/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 28 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 16,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 317657,
    title: 'NYC: Museum of the Moving Image Flexible Ticket',
    url: 'https://www.getyourguide.com/new-york-city-l59/nyc-museum-of-the-moving-image-flexible-ticket-t317657/',
    price: {
      original: '€ 14.05',
      min: '€ 14.05',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2661777-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2661777-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2661777-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2661777-53.jpg',
    smallDescription: 'Visit MoMI, the only museum in the United States dedicated to movies, television, and digital entertainment. Discover a museum sure to delight pop…',
    description: 'Visit MoMI, the only museum in the United States dedicated to movies, television, and digital entertainment. Discover a museum sure to delight pop culture and movie fans — and people of all ages — and marvel at The Jim Henson Exhibition.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2661777-68.jpg',
    imageAlt: 'nyc museum of the moving image flexible ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 2,
    totalRatingTitle: '2 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '14 - 31 days',
    validFrom: 'time_booked',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 17,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/nyc-museum-of-the-moving-image-flexible-ticket-t317657/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 14 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 17,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 19665,
    title: 'From Manhattan: Bronx, Queens and Brooklyn Half-Day Tour',
    url: 'https://www.getyourguide.com/queens-new-york-city-l87699/bronx-queens-and-brooklyn-new-york-triboro-half-day-tour-t19665/',
    price: {
      original: '€ 60.06',
      min: '€ 60.06',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3070695-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3070695-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3070695-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3070695-53.jpg',
    smallDescription: 'Visit parts of New York that aren’t usually featured on city tours. Your guide will take you to the Bronx, Queens, and Brooklyn to discover the real…',
    description: 'Visit parts of New York that aren’t usually featured on city tours. Your guide will take you to the Bronx, Queens, and Brooklyn to discover the real melting pot of America. See many distinct neighborhoods, where cultures from around the world thrive.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      39,
      55,
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3070695-68.jpg',
    imageAlt: 'from manhattan bronx queens and brooklyn halfday tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 307,
    totalRatingTitle: '307 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 18,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/queens-new-york-city-l87699/bronx-queens-and-brooklyn-new-york-triboro-half-day-tour-t19665/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/25/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 60 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 18,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 120557,
    title: 'Empire State Building: AM/PM Experience Ticket',
    url: 'https://www.getyourguide.com/new-york-city-l59/empire-state-building-day-and-night-experience-ticket-t120557/',
    price: {
      original: '€ 62.20',
      min: '€ 62.20',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-831371-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-831371-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-831371-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-831371-53.jpg',
    smallDescription: "Experience New York's highest open-air observatory twice in one day to feel the true pulse and romance of 24-hour Manhattan. Visit once in the…",
    description: 'Experience New York&#039;s highest open-air observatory twice in one day to feel the true pulse and romance of 24-hour Manhattan. Visit once in the daytime for endless views under the sun, and then again that same night - this time with sparkling city lights.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      88,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-831371-68.jpg',
    imageAlt: 'empire state building am/pm experience ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 34,
    totalRatingTitle: '34 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 19,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/empire-state-building-day-and-night-experience-ticket-t120557/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Saturday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 62 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 19,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 123038,
    title: 'NYC: 60-Min Statue of Liberty &amp; Ellis Island Sunset Cruise',
    url: 'https://www.getyourguide.com/new-york-city-l59/60-min-sunset-statue-of-liberty-ellis-island-cruise-t123038/',
    price: {
      original: '€ 32.78',
      min: '€ 26.22',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3064125-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3064125-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3064125-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3064125-53.jpg',
    smallDescription: 'Get up close to Lady Liberty and Ellis Island on the Sunset Cruise of the New York harbor. Sail around the Statue of Liberty, Ellis Island and the…',
    description: 'Get up close to Lady Liberty and Ellis Island on the Sunset Cruise of the New York harbor. Sail around the Statue of Liberty, Ellis Island and the Brooklyn Bridge. Enjoy the NYC Skyline and the sunsets and the lights of the City come to life.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      35,
      39,
      23,
      55,
      56,
      64,
      88,
    ],
    hasDeal: true,
    dealMaxPercentage: 20,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3064125-68.jpg',
    imageAlt: 'nyc 60min statue of liberty ellis island sunset cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 57,
    totalRatingTitle: '57 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '60 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 20,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/60-min-sunset-statue-of-liberty-ellis-island-cruise-t123038/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 26 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 20,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 15471,
    title: 'New York Skyline Cruise',
    url: 'https://www.getyourguide.com/new-york-city-l59/manhattan-skyline-cruise-t15471/',
    price: {
      original: '€ 32.78',
      min: '€ 32.78',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-203740-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-203740-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-203740-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-203740-53.jpg',
    smallDescription: 'Cruise around the New York harbor past such famous sights as the Statue of Liberty, the Brooklyn Bridge, and the rising World Trade Center. Enjoy…',
    description: 'Cruise around the New York harbor past such famous sights as the Statue of Liberty, the Brooklyn Bridge, and the rising World Trade Center. Enjoy 90-minutes of breathtaking views of the city while being guided by expert storytellers.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-203740-68.jpg',
    imageAlt: 'new york skyline cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.9',
    maxPossibleRating: 5,
    totalRating: 72,
    totalRatingTitle: '72 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 21,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/manhattan-skyline-cruise-t15471/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Saturday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 33 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 21,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 6813,
    title: 'New York City by Night Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-by-night-tour-t6813/',
    price: {
      original: '€ 55.26',
      min: '€ 55.26',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-727897-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-727897-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-727897-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-727897-53.jpg',
    smallDescription: 'See all of the sights of the Big Apple by night and watch the glittering lights on this fully guided tour. As you marvel at the illuminated…',
    description: 'See all of the sights of the Big Apple by night and watch the glittering lights on this fully guided tour. As you marvel at the illuminated attractions, your guide will provide expert commentary about the history and culture of New York.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
      23,
      35,
      39,
      45,
      55,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-727897-68.jpg',
    imageAlt: 'new york city by night tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.4',
    maxPossibleRating: 5,
    totalRating: 54,
    totalRatingTitle: '54 Reviews',
    averageRatingClass: '35',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 22,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-by-night-tour-t6813/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Saturday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 55 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 22,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 681,
    title: 'New York: 90-Minute Landmarks Cruise Skip-The-Box-Office',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-two-hour-cruise-t681/',
    price: {
      original: '€ 34.65',
      min: '€ 34.65',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-217143-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-217143-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-217143-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-217143-53.jpg',
    smallDescription: "If you want to see the best of New York and you're pressed for time, take this 90-minute Semi-Circle Cruise and experience the grandeur of lower and…",
    description: 'If you want to see the best of New York and you&#039;re pressed for time, take this 90-minute Semi-Circle Cruise and experience the grandeur of lower and midtown Manhattan. Get a close-up look at the Statue of Liberty and other sights best seen from the water.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-217143-68.jpg',
    imageAlt: 'new york 90minute landmarks cruise skiptheboxoffice',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 303,
    totalRatingTitle: '303 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 23,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-two-hour-cruise-t681/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/17/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 35 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 23,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 113641,
    title: 'New York City: Sunday Harlem Gospel Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-sunday-harlem-gospel-tour-t113641/',
    price: {
      original: '€ 60.88',
      min: '€ 60.88',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-793477-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-793477-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-793477-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-793477-53.jpg',
    smallDescription: 'Enjoy an historical guided tour through Harlem and join a local congregation for an uplifting service of gospel music on Sunday morning. See where…',
    description: 'Enjoy an historical guided tour through Harlem and join a local congregation for an uplifting service of gospel music on Sunday morning. See where Duke Ellington lived, explore the birth of urban black culture and more.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      39,
      35,
      109,
      55,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-793477-68.jpg',
    imageAlt: 'new york city sunday harlem gospel tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 115,
    totalRatingTitle: '115 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours - 4 days',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 24,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-sunday-harlem-gospel-tour-t113641/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/07/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 61 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 24,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 43502,
    title: 'JFK Airport to Manhattan Private Transfers',
    url: 'https://www.getyourguide.com/queens-new-york-city-l87699/jfk-airport-to-manhattan-private-transfers-t43502/',
    price: {
      original: '€ 123.69',
      min: '€ 123.69',
      type: 'group',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1016073-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1016073-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1016073-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1016073-53.jpg',
    smallDescription: 'Start or end your stay in New York with a hassle free private airport transfer from JFK Airport to hotels or private residences on Manhattan island.…',
    description: 'Start or end your stay in New York with a hassle free private airport transfer from JFK Airport to hotels or private residences on Manhattan island. Avoid the long cab lines upon arrival and relax in comfortable sedans or minivans to save time and money.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1016073-68.jpg',
    imageAlt: 'jfk airport to manhattan private transfers',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 287,
    totalRatingTitle: '287 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 25,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/queens-new-york-city-l87699/jfk-airport-to-manhattan-private-transfers-t43502/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 124 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 25,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 151778,
    title: 'New York City: Skyline at Night Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/half-day-panoramic-night-tour-of-new-york-city-t151778/',
    price: {
      original: '€ 51.51',
      min: '€ 51.51',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1096032-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1096032-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1096032-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1096032-53.jpg',
    smallDescription: "Take a picture-perfect evening/night tour of New York City - get amazing views of all of the city's main monuments and buildings, as well as a…",
    description: 'Take a picture-perfect evening/night tour of New York City - get amazing views of all of the city&#039;s main monuments and buildings, as well as a spectacular view of the city light up at night!',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1096032-68.jpg',
    imageAlt: 'new york city skyline at night tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.9',
    maxPossibleRating: 5,
    totalRating: 70,
    totalRatingTitle: '70 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 26,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/half-day-panoramic-night-tour-of-new-york-city-t151778/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 52 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 26,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 52377,
    title: 'New York: Big Bus Hop-On Hop-Off Sightseeing Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/24-or-48-hour-hop-on-hop-off-sightseeing-tour-t52377/',
    price: {
      original: '€ 51.51',
      min: '€ 46.36',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2365455-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2365455-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2365455-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2365455-53.jpg',
    smallDescription: 'Hop on board a sightseeing bus to discover the city that doesn’t sleep. Hop on and off as many times as you like with ticket options valid for 1, 2,…',
    description: 'Hop on board a sightseeing bus to discover the city that doesn’t sleep. Hop on and off as many times as you like with ticket options valid for 1, 2, or 3 days, and explore Downtown, and Uptown, with options including Harlem, Brooklyn and night tour.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      88,
      93,
    ],
    hasDeal: true,
    dealMaxPercentage: 10,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2365455-68.jpg',
    imageAlt: 'new york big bus hopon hopoff sightseeing tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.0',
    maxPossibleRating: 5,
    totalRating: 639,
    totalRatingTitle: '639 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '24 - 72 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 27,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/24-or-48-hour-hop-on-hop-off-sightseeing-tour-t52377/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 46 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 27,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 47360,
    title: 'Intrepid Sea, Air &amp; Space Museum: Priority Access Tickets',
    url: 'https://www.getyourguide.com/new-york-city-l59/intrepid-sea-air-space-museum-tickets-t47360/',
    price: {
      original: '€ 30.91',
      min: '€ 27.82',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736702-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736702-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736702-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736702-53.jpg',
    smallDescription: 'Take an interactive journey through history and innovation as you explore the legendary aircraft carrier "Intrepid", the space shuttle "Enterprise",…',
    description: 'Take an interactive journey through history and innovation as you explore the legendary aircraft carrier &quot;Intrepid&quot;, the space shuttle &quot;Enterprise&quot;, the world’s fastest jets and a guided missile submarine. Pre-book tickets for convenient Priority Access.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: true,
    dealMaxPercentage: 10,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-736702-68.jpg',
    imageAlt: 'intrepid sea air space museum priority access tickets',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 576,
    totalRatingTitle: '576 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '60 minutes - 1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 28,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/intrepid-sea-air-space-museum-tickets-t47360/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 28 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 28,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 282727,
    title: 'New York City: Catacombs by Candlelight',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-catacombs-by-candlelight-t282727/',
    price: {
      original: '€ 32.78',
      min: '€ 32.78',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2294447-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2294447-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2294447-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2294447-53.jpg',
    smallDescription: 'Go behind the scenes at the Basilica of St. Patrick’s Old Cathedral and see parts of the church that are otherwise off-limits to visitors. During…',
    description: 'Go behind the scenes at the Basilica of St. Patrick’s Old Cathedral and see parts of the church that are otherwise off-limits to visitors. During this unique experience you&#039;ll walk through the only catacombs in New York City open to daily tours.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2294447-68.jpg',
    imageAlt: 'new york city catacombs by candlelight',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 84,
    totalRatingTitle: '84 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 29,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-city-catacombs-by-candlelight-t282727/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 33 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 29,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 209550,
    title: 'New York: West Village Wine Tasting Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-west-village-wine-tasting-and-walking-tour-t209550/',
    price: {
      original: '€ 89.90',
      min: '€ 89.90',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2666172-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2666172-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2666172-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2666172-53.jpg',
    smallDescription: 'Visit two premium wine destinations in West Village during your wine-tasting walking tour. At each stop, sample world-class wines matched with…',
    description: 'Visit two premium wine destinations in West Village during your wine-tasting walking tour. At each stop, sample world-class wines matched with delicious cuisine while your certified Wine Ambassador shares tips on selecting, tasting, and pairing wines.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2666172-68.jpg',
    imageAlt: 'new york west village wine tasting tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 1,
    totalRatingTitle: '1 Review',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 30,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-west-village-wine-tasting-and-walking-tour-t209550/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/25/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 90 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 30,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 134331,
    title: 'Statue of Liberty with Pedestal Access &amp; Ellis Island Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/statue-of-liberty-ellis-island-vip-tour-with-crown-access-t134331/',
    price: {
      original: '€ 48.42',
      min: '€ 48.42',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2129972-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2129972-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2129972-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2129972-53.jpg',
    smallDescription: 'No trip to New York would be complete without visiting and learning about one of the most well-known monuments in the world: the Statue of Liberty…',
    description: 'No trip to New York would be complete without visiting and learning about one of the most well-known monuments in the world: the Statue of Liberty and the Immigration Museum at Ellis Island. This tour includes admission to the statue&#039;s pedestal.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2129972-68.jpg',
    imageAlt: 'statue of liberty with pedestal access ellis island tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 261,
    totalRatingTitle: '261 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 31,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/statue-of-liberty-ellis-island-vip-tour-with-crown-access-t134331/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 48 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 31,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 83253,
    title: 'Harlem: Sunday Gospel Service with Locals',
    url: 'https://www.getyourguide.com/new-york-city-l59/sunday-gospel-in-harlem-t83253/',
    price: {
      original: '€ 23.41',
      min: '€ 23.41',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-551232-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-551232-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-551232-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-551232-53.jpg',
    smallDescription: 'Sunday Gospel in Harlem invites you to be a part of this custom by respectfully joining a local church family for an hour of worship including gospel.',
    description: 'Sunday Gospel in Harlem invites you to be a part of this custom by respectfully joining a local church family for an hour of worship including gospel.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-551232-68.jpg',
    imageAlt: 'harlem sunday gospel service with locals',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.8',
    maxPossibleRating: 5,
    totalRating: 78,
    totalRatingTitle: '78 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 32,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/sunday-gospel-in-harlem-t83253/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Sunday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 23 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 32,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 309563,
    title: 'NYC: Guggenheim Museum Admission Ticket w/Skip the Main Line',
    url: 'https://www.getyourguide.com/guggenheim-museum-new-york-l4793/guggenheim-museum-entrance-ticket-t309563/',
    price: {
      original: '€ 23.41',
      min: '€ 23.41',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2575928-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2575928-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2575928-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2575928-53.jpg',
    smallDescription: "Visit Frank Lloyd Wright's iconic architectural masterpiece, housing one of the world’s finest collections of modern and contemporary art. Pre-book…",
    description: 'Visit Frank Lloyd Wright&#039;s iconic architectural masterpiece, housing one of the world’s finest collections of modern and contemporary art. Pre-book tickets for skip-the-line and re-entry privileges. Upgrade to include the Weekend Architecture Tour.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2575928-68.jpg',
    imageAlt: 'nyc guggenheim museum admission ticket w/skip the main line',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 445,
    totalRatingTitle: '445 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 33,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/guggenheim-museum-new-york-l4793/guggenheim-museum-entrance-ticket-t309563/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 23 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 33,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 72883,
    title: 'Brooklyn Graffiti Lesson',
    url: 'https://www.getyourguide.com/brooklyn-l2034/brooklyn-graffiti-lesson-t72883/',
    price: {
      original: '€ 28.10',
      min: '€ 28.10',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-483091-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-483091-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-483091-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-483091-53.jpg',
    smallDescription: 'Take a fun and arty graffiti lesson in Brooklyn and learn technical skills while creating a unique souvenir to take home with you.',
    description: 'Take a fun and arty graffiti lesson in Brooklyn and learn technical skills while creating a unique souvenir to take home with you.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-483091-68.jpg',
    imageAlt: 'brooklyn graffiti lesson',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 29,
    totalRatingTitle: '29 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 34,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/brooklyn-l2034/brooklyn-graffiti-lesson-t72883/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 28 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 34,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 108082,
    title: 'New York: Harbor Lights Night Cruise Skip-The-Box-Office',
    url: 'https://www.getyourguide.com/new-york-city-l59/harbor-lights-night-cruise-t108082/',
    price: {
      original: '€ 38.40',
      min: '€ 38.40',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-771769-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-771769-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-771769-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-771769-53.jpg',
    smallDescription: 'Climb aboard for a 2-hour twilight cruise of New York Harbor and relax with your favorite cocktail as you enjoy the incredible sunset views of…',
    description: 'Climb aboard for a 2-hour twilight cruise of New York Harbor and relax with your favorite cocktail as you enjoy the incredible sunset views of Manhattan and listen to your expert guide&#039;s commentary about the sights of interest.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-771769-68.jpg',
    imageAlt: 'new york harbor lights night cruise skiptheboxoffice',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 786,
    totalRatingTitle: '786 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 35,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/harbor-lights-night-cruise-t108082/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/17/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 38 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 35,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 56169,
    title: '9/11 Tribute Museum Ticket',
    url: 'https://www.getyourguide.com/new-york-city-l59/911-tribute-center-admission-t56169/',
    price: {
      original: '€ 14.05',
      min: '€ 14.05',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-787573-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-787573-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-787573-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-787573-53.jpg',
    smallDescription: 'Visit the exhibitions at the 9/11 Tribute Museum and understand the events surrounding America’s largest emergency response and recovery effort. The…',
    description: 'Visit the exhibitions at the 9/11 Tribute Museum and understand the events surrounding America’s largest emergency response and recovery effort. The Tribute Museum shares personal stories and thought-provoking exhibits about the events of 9/11.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-787573-68.jpg',
    imageAlt: '9/11 tribute museum ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.0',
    maxPossibleRating: 5,
    totalRating: 34,
    totalRatingTitle: '34 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.0 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 36,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/911-tribute-center-admission-t56169/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 14 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 36,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 61160,
    title: 'Statue of Liberty: Pedestal Express and Ellis Island',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-statue-of-liberty-ellis-island-guided-tour-t61160/',
    price: {
      original: '€ 45.88',
      min: '€ 45.88',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-738757-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-738757-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-738757-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-738757-53.jpg',
    smallDescription: 'Experience the Statue of Liberty with an Exclusive Pedestal Pass. Enjoy an easy, stress-free visit with a knowledgeable guide leading the way.…',
    description: 'Experience the Statue of Liberty with an Exclusive Pedestal Pass. Enjoy an easy, stress-free visit with a knowledgeable guide leading the way. Reserve your spot now to guarantee your pedestal entry and skip the long ticket lines the day of your visit.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-738757-68.jpg',
    imageAlt: 'statue of liberty pedestal express and ellis island',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 910,
    totalRatingTitle: '910 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3 - 4.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 37,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-statue-of-liberty-ellis-island-guided-tour-t61160/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 46 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 37,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 25805,
    title: 'Ground Zero 9/11 Memorial Tour &amp; Optional 9/11 Museum Entry',
    url: 'https://www.getyourguide.com/new-york-city-l59/ground-zero-tour-911-memorial-entrance-t25805/',
    price: {
      original: '€ 32.78',
      min: '€ 32.78',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2332850-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2332850-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2332850-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2332850-53.jpg',
    smallDescription: 'Visit Ground Zero, the 9/11 Memorial, and other historic locations as you hear stories of tragedy, heroism, and hope from guides with a personal…',
    description: 'Visit Ground Zero, the 9/11 Memorial, and other historic locations as you hear stories of tragedy, heroism, and hope from guides with a personal connection to the events. Purchase the option with 9/11 Museum entry to see artifacts preserved from this day.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      35,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2332850-68.jpg',
    imageAlt: 'ground zero 9/11 memorial tour optional 9/11 museum entry',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 509,
    totalRatingTitle: '509 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes - 5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 38,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/ground-zero-tour-911-memorial-entrance-t25805/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 33 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 38,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 134295,
    title: 'Central Park: Live Guided Bike Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/central-park-bicycle-tour-t134295/',
    price: {
      original: '€ 30.91',
      min: '€ 30.91',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3339609-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3339609-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3339609-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3339609-53.jpg',
    smallDescription: 'Enjoy a bike ride in Central Park with a licensed guide. See popular destinations, including the Bethesda Fountain, Strawberry Fields and others.',
    description: 'Enjoy a bike ride in Central Park with a licensed guide. See popular destinations, including the Bethesda Fountain, Strawberry Fields and others.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3339609-68.jpg',
    imageAlt: 'central park live guided bike tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 53,
    totalRatingTitle: '53 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 39,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/central-park-bicycle-tour-t134295/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 31 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 39,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 74161,
    title: 'New York City: 4-Hour Bike Rental',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-4-hour-bike-rental-t74161/',
    price: {
      original: '€ 12.18',
      min: '€ 12.18',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-540270-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-540270-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-540270-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-540270-53.jpg',
    smallDescription: "Explore New York by bike with an all-inclusive 4-hour rental package. Head into the world's most famous urban park or ride the dedicated greenways.…",
    description: 'Explore New York by bike with an all-inclusive 4-hour rental package. Head into the world&#039;s most famous urban park or ride the dedicated greenways. Get a free map, helmet and chain-lock for your safety and to help plan your self-guided tour.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-540270-68.jpg',
    imageAlt: 'new york city 4hour bike rental',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 216,
    totalRatingTitle: '216 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 40,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-4-hour-bike-rental-t74161/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 12 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 40,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 53542,
    title: 'Statue of Liberty &amp; Ellis Island with Pedestal Access Option',
    url: 'https://www.getyourguide.com/new-york-city-l59/statue-of-liberty-and-ellis-island-4-hour-guided-tour-t53542/',
    price: {
      original: '€ 45.89',
      min: '€ 45.89',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1295946-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1295946-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1295946-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1295946-53.jpg',
    smallDescription: 'Take a guided tour of the Statue of Liberty and Ellis Island with an expert. You’ll have early reserve line access to the Statue Ferry, and have…',
    description: 'Take a guided tour of the Statue of Liberty and Ellis Island with an expert. You’ll have early reserve line access to the Statue Ferry, and have ample time to explore these 2 important attractions on an express 2-hour or comprehensive 4-hour tour.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      35,
      109,
      56,
      23,
      39,
      93,
      55,
      6,
      46,
      64,
      88,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1295946-68.jpg',
    imageAlt: 'statue of liberty ellis island with pedestal access option',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 1938,
    totalRatingTitle: '1938 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2.5 - 4 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 41,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/statue-of-liberty-and-ellis-island-4-hour-guided-tour-t53542/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Sunday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 46 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 41,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 155448,
    title: 'From Manhattan: 2-Hour Brooklyn Bridge Guided Bike Tour',
    url: 'https://www.getyourguide.com/brooklyn-l2034/brooklyn-bridge-bicycle-tour-t155448/',
    price: {
      original: '€ 30.91',
      min: '€ 30.91',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1998942-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1998942-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1998942-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1998942-53.jpg',
    smallDescription: 'Take a Brooklyn Bridge bicycle tour with a licensed professional tour guide. This tour focuses on the architecture, art, and history of the Brooklyn…',
    description: 'Take a Brooklyn Bridge bicycle tour with a licensed professional tour guide. This tour focuses on the architecture, art, and history of the Brooklyn Bridge.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1998942-68.jpg',
    imageAlt: 'from manhattan 2hour brooklyn bridge guided bike tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 3,
    totalRatingTitle: '3 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 42,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/brooklyn-l2034/brooklyn-bridge-bicycle-tour-t155448/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 31 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 42,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 72309,
    title: 'Broadway Theatre District Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/broadway-theatre-district-tour-t72309/',
    price: {
      original: '€ 32.78',
      min: '€ 32.78',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1810992-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1810992-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1810992-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1810992-53.jpg',
    smallDescription: "Experience the Great White Way with an industry professional and walk in the footsteps of some of the world's greatest artists.",
    description: 'Experience the Great White Way with an industry professional and walk in the footsteps of some of the world&#039;s greatest artists.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1810992-68.jpg',
    imageAlt: 'broadway theatre district tour',
    isFreeCancellation: true,
    hasRating: false,
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 43,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/broadway-theatre-district-tour-t72309/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 33 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 43,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 27351,
    title: 'New Year&#039;s Eve Fireworks Cruise and Champagne Tasting',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-year-s-eve-fireworks-cruise-on-yacht-manhattan-t27351/',
    price: {
      original: '€ 385.44',
      min: '€ 385.44',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-140238-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-140238-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-140238-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-140238-53.jpg',
    smallDescription: "Spend New Year's Eve on the Yacht Manhattan II and watch the New York Harbor New Year's Eve fireworks show dazzle the sky as you sip champagne aboard…",
    description: 'Spend New Year&#039;s Eve on the Yacht Manhattan II and watch the New York Harbor New Year&#039;s Eve fireworks show dazzle the sky as you sip champagne aboard a luxury yacht. While you wait for the show to start, enjoy a champagne tasting class with a wine expert.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-140238-68.jpg',
    imageAlt: 'new years eve fireworks cruise and champagne tasting',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 1,
    totalRatingTitle: '1 Review',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 44,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-year-s-eve-fireworks-cruise-on-yacht-manhattan-t27351/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 01/01/2021',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 385 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 44,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 193832,
    title: 'Standard Central Park Horse Carriage Ride',
    url: 'https://www.getyourguide.com/new-york-city-l59/standard-central-park-horse-carriage-ride-t193832/',
    price: {
      original: '€ 130.18',
      min: '€ 130.18',
      type: 'group',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2751793-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2751793-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2751793-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2751793-53.jpg',
    smallDescription: 'Discover the natural beauty and main attractions of Central Park during a 40-minute carriage ride. Perfect for a romantic occasion or fun-loving…',
    description: 'Discover the natural beauty and main attractions of Central Park during a 40-minute carriage ride. Perfect for a romantic occasion or fun-loving families, the tour is a great way to see the landmarks of the world famous park without getting worn out.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2751793-68.jpg',
    imageAlt: 'standard central park horse carriage ride',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 23,
    totalRatingTitle: '23 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '40 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 45,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/standard-central-park-horse-carriage-ride-t193832/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 130 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 45,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 9481,
    title: 'Wall Street Insider Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/wall-street-insider-tour-t9481/',
    price: {
      original: '€ 32.78',
      min: '€ 32.78',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-737740-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-737740-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-737740-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-737740-53.jpg',
    smallDescription: "Explore the world's financial center with a Wall Street insider! You’ll see the New York Stock Exchange, the Federal Reserve, and Wall Street. Your…",
    description: 'Explore the world&#039;s financial center with a Wall Street insider! You’ll see the New York Stock Exchange, the Federal Reserve, and Wall Street. Your guide will personalize the tour by adding stories from their own experiences inside the belly of the beast.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-737740-68.jpg',
    imageAlt: 'wall street insider tour',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 135,
    totalRatingTitle: '135 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '75 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 46,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/wall-street-insider-tour-t9481/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 33 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 46,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 9089,
    title: '2-Day Niagara Falls and Shopping Trip from New York City',
    url: 'https://www.getyourguide.com/new-york-city-l59/2-day-niagara-falls-and-shopping-trip-from-new-york-city-t9089/',
    price: {
      original: '€ 318.43',
      min: '€ 286.58',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736180-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736180-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736180-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-736180-53.jpg',
    smallDescription: 'Escape the bustle of New York City on a 2-day excursion to Niagara Falls. Experience both the U.S. and Canada sides of the Falls, and ride on the…',
    description: 'Escape the bustle of New York City on a 2-day excursion to Niagara Falls. Experience both the U.S. and Canada sides of the Falls, and ride on the famous Maid of the Mist boat under the Falls. Enjoy time to shop and sleep in comfortable accommodation.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      35,
      39,
      55,
      109,
      88,
      23,
      45,
      56,
    ],
    hasDeal: true,
    dealMaxPercentage: 10,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-736180-68.jpg',
    imageAlt: '2day niagara falls and shopping trip from new york city',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 335,
    totalRatingTitle: '335 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 days',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 47,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/2-day-niagara-falls-and-shopping-trip-from-new-york-city-t9089/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/02/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 287 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 47,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 314867,
    title: 'Statue of Liberty Pedestal, Ellis Island &amp; Pre-Ferry Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/statue-of-liberty-ferry-ticket-with-pedestal-access-t314867/',
    price: {
      original: '€ 56.18',
      min: '€ 44.95',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2632167-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2632167-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2632167-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2632167-53.jpg',
    smallDescription: 'Take a 30-minute live guided tour in English of Battery Park and guaranteed access to the Statue of Liberty Pedestal and Ellis Island. Explore with…',
    description: 'Take a 30-minute live guided tour in English of Battery Park and guaranteed access to the Statue of Liberty Pedestal and Ellis Island. Explore with audio guides or upgrade to include a fully-escorted guided tour of Liberty Island and Ellis Island.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      6,
      23,
      35,
      39,
      55,
      56,
      93,
      109,
    ],
    hasDeal: true,
    dealMaxPercentage: 20,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2632167-68.jpg',
    imageAlt: 'statue of liberty pedestal ellis island preferry tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 1434,
    totalRatingTitle: '1434 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3 - 5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 48,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/statue-of-liberty-ferry-ticket-with-pedestal-access-t314867/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 45 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 48,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 105856,
    title: 'New York City Food Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/secret-food-tours-new-york-city-t105856/',
    price: {
      original: '€ 71.09',
      min: '€ 71.09',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1853692-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1853692-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1853692-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1853692-53.jpg',
    smallDescription: 'This 3-hour tour will unlock the secret history of this historic district, as well as secret food havens nestled throughout this beautiful enclave.',
    description: 'This 3-hour tour will unlock the secret history of this historic district, as well as secret food havens nestled throughout this beautiful enclave.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1853692-68.jpg',
    imageAlt: 'new york city food tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 11,
    totalRatingTitle: '11 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 49,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/secret-food-tours-new-york-city-t105856/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/07/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 71 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 49,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 298070,
    title: 'NYC: The Temptations Ain&#039;t Too Proud Musical Ticket',
    url: 'https://www.getyourguide.com/midtown-manhattan-l98088/nyc-the-temptations-ain-t-too-proud-musical-ticket-t298070/',
    price: {
      original: '€ 62.87',
      min: '€ 62.87',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3015681-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3015681-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3015681-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3015681-53.jpg',
    smallDescription: 'Discover the electrifying new musical that follows The Temptations’ extraordinary journey from the streets of Detroit to the Rock & Roll Hall of…',
    description: 'Discover the electrifying new musical that follows The Temptations’ extraordinary journey from the streets of Detroit to the Rock &amp; Roll Hall of Fame. Witness all the magic of &quot;Ain&#039;t Too Proud&quot; for yourself.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3015681-68.jpg',
    imageAlt: 'nyc the temptations aint too proud musical ticket',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 3,
    totalRatingTitle: '3 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 50,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/midtown-manhattan-l98088/nyc-the-temptations-ain-t-too-proud-musical-ticket-t298070/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 09/08/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 63 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 50,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 683,
    title: 'NYC: The Beast Speedboat Skip the Box Office Ticket',
    url: 'https://www.getyourguide.com/new-york-city-l59/beast-speedboat-ride-t683/',
    price: {
      original: '€ 28.10',
      min: '€ 28.10',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2363075-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2363075-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2363075-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2363075-53.jpg',
    smallDescription: 'Pound New York Harbor on an adrenaline-fuelled speedboat ride. Race past New York highlights on the 30-minute tour, accompanied to a thumping…',
    description: 'Pound New York Harbor on an adrenaline-fuelled speedboat ride. Race past New York highlights on the 30-minute tour, accompanied to a thumping soundtrack to make the adventure more epic and cinematic.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2363075-68.jpg',
    imageAlt: 'nyc the beast speedboat skip the box office ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 99,
    totalRatingTitle: '99 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '30 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 51,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/beast-speedboat-ride-t683/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 28 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 51,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 71571,
    title: 'JFK and LaGuardia Airport 1-Way Transfer to Manhattan',
    url: 'https://www.getyourguide.com/brooklyn-l2034/jfk-and-lga-airport-transportation-to-hotels-t71571/',
    price: {
      original: '€ 14.98',
      min: '€ 14.98',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1857587-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1857587-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1857587-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1857587-53.jpg',
    smallDescription: 'Take the worry out of your transportation needs to or from LaGuardia or JFK Airport with a 1-way transfer to the Port Authority Bus Terminal and…',
    description: 'Take the worry out of your transportation needs to or from LaGuardia or JFK Airport with a 1-way transfer to the Port Authority Bus Terminal and Grand Central Station for bus and train links and hotels in Manhattan.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1857587-68.jpg',
    imageAlt: 'jfk and laguardia airport 1way transfer to manhattan',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.8',
    maxPossibleRating: 5,
    totalRating: 50,
    totalRatingTitle: '50 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 - 1.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 52,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/brooklyn-l2034/jfk-and-lga-airport-transportation-to-hotels-t71571/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available today and tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 52,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 158151,
    title: 'Central Park Bike Rental All Day',
    url: 'https://www.getyourguide.com/new-york-city-l59/central-park-all-day-bike-rental-t158151/',
    price: {
      original: '€ 18.73',
      min: '€ 18.73',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1129209-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1129209-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1129209-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1129209-53.jpg',
    smallDescription: "Rent a bike for a day and explore Central Park with the aid of a map that's included with the rental. See much more by bike than you could on foot.",
    description: 'Rent a bike for a day and explore Central Park with the aid of a map that&#039;s included with the rental. See much more by bike than you could on foot.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1129209-68.jpg',
    imageAlt: 'central park bike rental all day',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 18,
    totalRatingTitle: '18 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 53,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/central-park-all-day-bike-rental-t158151/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 19 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 53,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 8915,
    title: 'Washington, D.C. Day Trip from New York',
    url: 'https://www.getyourguide.com/new-york-city-l59/washington-dc-day-trip-from-new-york-t8915/',
    price: {
      original: '€ 158.28',
      min: '€ 142.45',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-236574-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-236574-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-236574-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-236574-53.jpg',
    smallDescription: 'Visit the political center of the world on this day trip from New York to the Capital City of Washington, D.C. See the White House, the Mall, and…',
    description: 'Visit the political center of the world on this day trip from New York to the Capital City of Washington, D.C. See the White House, the Mall, and many other monuments, and visit Arlington National Cemetery and see the gravesite of John F. Kennedy.',
    isBestseller: true,
    isFeatured: false,
    languageIds: [
      29,
      35,
      39,
      55,
      109,
      88,
      23,
      45,
      56,
    ],
    hasDeal: true,
    dealMaxPercentage: 10,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: true,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-236574-68.jpg',
    imageAlt: 'washington d.c. day trip from new york',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 1114,
    totalRatingTitle: '1114 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '14 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 54,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/washington-dc-day-trip-from-new-york-t8915/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 142 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 54,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 108052,
    title: 'Meal at Hard Rock Cafe New York Times Square',
    url: 'https://www.getyourguide.com/new-york-city-l59/meal-at-hard-rock-cafe-new-york-in-times-square-t108052/',
    price: {
      original: '€ 34.34',
      min: '€ 34.34',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-730819-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-730819-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-730819-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-730819-53.jpg',
    smallDescription: "Dine on classic American food in an iconic location with lunch or dinner at the Hard Rock Cafe in New York's Times Square. Choose from 2 unique…",
    description: 'Dine on classic American food in an iconic location with lunch or dinner at the Hard Rock Cafe in New York&#039;s Times Square. Choose from 2 unique dining experiences, served in an energetic setting.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-730819-68.jpg',
    imageAlt: 'meal at hard rock cafe new york times square',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 37,
    totalRatingTitle: '37 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 55,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/meal-at-hard-rock-cafe-new-york-in-times-square-t108052/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Friday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 34 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 55,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 304118,
    title: 'New York City: Dyker Heights Christmas Lights Tour',
    url: 'https://www.getyourguide.com/dumbo-new-york-l86477/new-york-city-dyker-heights-christmas-lights-tour-t304118/',
    price: {
      original: '€ 42.14',
      min: '€ 42.14',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2543083-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2543083-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2543083-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2543083-53.jpg',
    smallDescription: "On this Spanish language tour, visit Brooklyn's Dyker Heights neighborhood. Famous for it's Christmas lights, you can marvel at some of the best…",
    description: 'On this Spanish language tour, visit Brooklyn&#039;s Dyker Heights neighborhood. Famous for it&#039;s Christmas lights, you can marvel at some of the best Christmas decorations in New York City.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2543083-68.jpg',
    imageAlt: 'new york city dyker heights christmas lights tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 1,
    totalRatingTitle: '1 Review',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 56,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/dumbo-new-york-l86477/new-york-city-dyker-heights-christmas-lights-tour-t304118/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 12/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 42 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 56,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 46313,
    title: 'New York: Rock the Yacht 3-Hour Party Cruise',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-rock-the-yacht-cruise-t46313/',
    price: {
      original: '€ 32.78',
      min: '€ 32.78',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1746577-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1746577-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1746577-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1746577-53.jpg',
    smallDescription: 'Pick up the tempo and rock the night away aboard a 3-hour party cruise around New York harbor.',
    description: 'Pick up the tempo and rock the night away aboard a 3-hour party cruise around New York harbor.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1746577-68.jpg',
    imageAlt: 'new york rock the yacht 3hour party cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.7',
    maxPossibleRating: 5,
    totalRating: 12,
    totalRatingTitle: '12 Reviews',
    averageRatingClass: '35',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 57,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-rock-the-yacht-cruise-t46313/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Saturday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 33 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 57,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 116338,
    title: 'New York City Harlem Highlights w/ Gospel Concert &amp; Transfer',
    url: 'https://www.getyourguide.com/new-york-city-l59/harlem-gospel-tour-wednesday-t116338/',
    price: {
      original: '€ 60.88',
      min: '€ 60.88',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-795850-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-795850-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-795850-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-795850-53.jpg',
    smallDescription: "Sit in comfort while being transported back in time to Harlem's multicultural history on the way to historical Harlem sites. Immerse yourself in a…",
    description: 'Sit in comfort while being transported back in time to Harlem&#039;s multicultural history on the way to historical Harlem sites. Immerse yourself in a gospel choir concert to feel the true Harlem experience.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      35,
      55,
      39,
      109,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-795850-68.jpg',
    imageAlt: 'new york city harlem highlights w/ gospel concert transfer',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 62,
    totalRatingTitle: '62 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 58,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/harlem-gospel-tour-wednesday-t116338/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 61 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 58,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 232577,
    title: 'New York: Media Boat High Speed Boat Tour',
    url: 'https://www.getyourguide.com/new-york-city-l59/new-york-harbor-high-speed-boat-tour-t232577/',
    price: {
      original: '€ 88.97',
      min: '€ 88.97',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1782627-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1782627-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1782627-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1782627-53.jpg',
    smallDescription: 'Explore New York Harbor aboard a fast military-style boat on a narrated sightseeing tour. Speed along on the Hudson River and see the Statue of…',
    description: 'Explore New York Harbor aboard a fast military-style boat on a narrated sightseeing tour. Speed along on the Hudson River and see the Statue of Liberty, Brooklyn Bridge and other top sights.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1782627-68.jpg',
    imageAlt: 'new york media boat high speed boat tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 8,
    totalRatingTitle: '8 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 59,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/new-york-city-l59/new-york-harbor-high-speed-boat-tour-t232577/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 89 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 59,
    highlightedOrientation: 'horizontal',
  },
];

export const toursParis = [
  {
    tourId: 175122,
    title: 'Ultimate Louvre: Fast-Track Guided Tour With Ticket',
    url: 'https://www.getyourguide.com/paris-l16/ultimate-louvre-2-hour-skip-the-line-guided-tour-t175122/',
    price: {
      original: '€ 65',
      min: '€ 65',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1341956-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1341956-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1341956-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1341956-53.jpg',
    smallDescription: 'Head in faster and see art from an expert’s perspective, follow a smart route through the Louvre to get up close to “Mona Lisa”, with time to stop…',
    description: 'Head in faster and see art from an expert’s perspective, follow a smart route through the Louvre to get up close to “Mona Lisa”, with time to stop and take photos.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      39,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: true,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1341956-68.jpg',
    imageAlt: 'ultimate louvre fasttrack guided tour with ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 1632,
    totalRatingTitle: '1632 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 0,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/ultimate-louvre-2-hour-skip-the-line-guided-tour-t175122/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/15/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 65 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 0,
    highlightedOrientation: 'horizontal',
    keyDetails: {
      duration: {
        label: 'Duration:',
        description: '2 hours',
      },
      cancellation_policy: {
        label: 'Easy cancellation',
        description: 'Cancel up to 24 hours in advance for a full refund',
      },
      skip_the_line: {
        label: 'Skip the ticket line',
        description: '',
      },
      instant_confirmation: {
        label: 'Instant confirmation',
        description: '',
      },
    },
  },
  {
    tourId: 175182,
    title: 'Ultimate Versailles: Skip-the-Line Guided Tour',
    url: 'https://www.getyourguide.com/paris-l16/ultimate-versailles-90-minute-skip-the-line-guided-tour-t175182/',
    price: {
      original: '€ 45',
      min: '€ 45',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1276647-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1276647-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1276647-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1276647-53.jpg',
    smallDescription: "Enjoy an exclusive guided tour of one of the largest palaces in the world. See the State Apartments, the King's Bedroom, the Hall of Mirrors, and…",
    description: 'Enjoy an exclusive guided tour of one of the largest palaces in the world. See the State Apartments, the King&#039;s Bedroom, the Hall of Mirrors, and more.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: true,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1276647-68.jpg',
    imageAlt: 'ultimate versailles skiptheline guided tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 902,
    totalRatingTitle: '902 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 1,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/ultimate-versailles-90-minute-skip-the-line-guided-tour-t175182/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/11/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 45 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 1,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 193940,
    title: 'Paris: 1-hour River Seine Cruise',
    url: 'https://www.getyourguide.com/paris-l16/bateaux-parisiens-cruise-quick-entry-ticket-t193940/',
    price: {
      original: '€ 16.99',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2345180-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2345180-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2345180-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2345180-53.jpg',
    smallDescription: 'Admire the iconic sights of Paris on a relaxing River Seine cruise. Enjoy audioguide commentary and learn about sites such as the Eiffel Tower and…',
    description: 'Admire the iconic sights of Paris on a relaxing River Seine cruise. Enjoy audioguide commentary and learn about sites such as the Eiffel Tower and Notre Dame.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: true,
    dealMaxPercentage: 11.700000000000003,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2345180-68.jpg',
    imageAlt: 'paris 1hour river seine cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 3802,
    totalRatingTitle: '3802 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 2,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/bateaux-parisiens-cruise-quick-entry-ticket-t193940/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 2,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 59565,
    title: 'Versailles Palace &amp; Gardens Full Access Ticket &amp; Audio Guide',
    url: 'https://www.getyourguide.com/paris-l16/palace-of-versailles-full-access-passport-ticket-t59565/',
    price: {
      original: '€ 20',
      min: '€ 20',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740775-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740775-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740775-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740775-53.jpg',
    smallDescription: "Enjoy 1 or 2 days full access to Versailles' whole domain, including the palace, Trianon, Marie Antoinette's Estate and gardens. Benefit from an…",
    description: 'Enjoy 1 or 2 days full access to Versailles&#039; whole domain, including the palace, Trianon, Marie Antoinette&#039;s Estate and gardens. Benefit from an audio guide in the palace. Upgrade and see the famous Musical Gardens or Fountain Show.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      87,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: true,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740775-68.jpg',
    imageAlt: 'versailles palace gardens full access ticket audio guide',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 8277,
    totalRatingTitle: '8277 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 - 2 days',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 3,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/palace-of-versailles-full-access-passport-ticket-t59565/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 20 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 3,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 65756,
    title: 'Musée d&#039;Orsay Reserved Access 1-Day Admission Ticket',
    url: 'https://www.getyourguide.com/paris-l16/orsay-museum-skip-the-line-entrance-ticket-t65756/',
    price: {
      original: '€ 17',
      min: '€ 17',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-460272-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-460272-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-460272-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-460272-53.jpg',
    smallDescription: "Get reserved access to the Musée d'Orsay in Paris and enjoy more time inside to see the artistic masterpieces of one of the world’s greatest museums.…",
    description: 'Get reserved access to the Musée d&#039;Orsay in Paris and enjoy more time inside to see the artistic masterpieces of one of the world’s greatest museums. Admire works by Impressionists and Post-Impressionists, including Renoir and Van Gogh.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-460272-68.jpg',
    imageAlt: 'musée dorsay reserved access 1day admission ticket',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 4554,
    totalRatingTitle: '4554 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 4,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/orsay-museum-skip-the-line-entrance-ticket-t65756/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 17 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 4,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 19562,
    title: 'Disneyland Paris 1-Day Ticket',
    url: 'https://www.getyourguide.com/paris-l16/disneyland-paris-2-parks-ticket-1-2-3-4-5-day-t19562/',
    price: {
      original: '€ 59',
      min: '€ 59',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2277592-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2277592-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2277592-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2277592-53.jpg',
    smallDescription: 'Enjoy a magical time at Disneyland® Paris with standard FASTPASS® service to select attractions. Choose to access Walt Disney Studios® Park or…',
    description: 'Enjoy a magical time at Disneyland® Paris with standard FASTPASS® service to select attractions. Choose to access Walt Disney Studios® Park or Disneyland® Park or both if the option is selected.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2277592-68.jpg',
    imageAlt: 'disneyland paris 1day ticket',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 10319,
    totalRatingTitle: '10319 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 5,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/disneyland-paris-2-parks-ticket-1-2-3-4-5-day-t19562/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 10/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 59 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 5,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 193898,
    title: 'Paris: 1-Hour Illuminations River Cruise',
    url: 'https://www.getyourguide.com/paris-l16/paris-1-hour-illuminations-river-cruise-t193898/',
    price: {
      original: '€ 16.99',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1437935-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1437935-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1437935-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1437935-53.jpg',
    smallDescription: 'Admire the beautiful monuments of Paris illuminated for the evening on an enjoyable 1-hour on the River Seine.',
    description: 'Admire the beautiful monuments of Paris illuminated for the evening on an enjoyable 1-hour on the River Seine.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: true,
    dealMaxPercentage: 11.700000000000003,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1437935-68.jpg',
    imageAlt: 'paris 1hour illuminations river cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 3360,
    totalRatingTitle: '3360 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 6,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-1-hour-illuminations-river-cruise-t193898/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 6,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 66157,
    title: 'Paris: Skip-the-Line Arc de Triomphe Rooftop Tickets',
    url: 'https://www.getyourguide.com/paris-l16/paris-skip-the-line-arc-de-triomphe-tickets-t66157/',
    price: {
      original: '€ 13',
      min: '€ 13',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-660330-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-660330-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-660330-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-660330-53.jpg',
    smallDescription: "Come and visit the Arc de Triomphe at Place de l'Étoile. Skip the lines to reach the top of the Champs-Élysées and feast your eyes on breathtaking…",
    description: 'Come and visit the Arc de Triomphe at Place de l&#039;Étoile. Skip the lines to reach the top of the Champs-Élysées and feast your eyes on breathtaking panoramas of the world-renowned City of Love.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-660330-68.jpg',
    imageAlt: 'paris skiptheline arc de triomphe rooftop tickets',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 3576,
    totalRatingTitle: '3576 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '365 days',
    validFrom: 'time_booked',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 7,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-skip-the-line-arc-de-triomphe-tickets-t66157/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/22/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 13 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 7,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 385521,
    title: 'Versailles Palace: Virtual Tour with French History Expert',
    url: 'https://www.getyourguide.com/paris-l16/versailles-palace-virtual-tour-with-french-history-expert-t385521/',
    price: {
      original: '€ 15',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433058-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433058-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433058-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433058-53.jpg',
    smallDescription: 'Join a licensed historian on a fully interactive virtual tour of the Palace of Versailles filled with photos, videos, polls, and a live Q&A.',
    description: 'Join a licensed historian on a fully interactive virtual tour of the Palace of Versailles filled with photos, videos, polls, and a live Q&amp;A.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433058-68.jpg',
    imageAlt: 'versailles palace virtual tour with french history expert',
    isFreeCancellation: true,
    hasRating: false,
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 8,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/versailles-palace-virtual-tour-with-french-history-expert-t385521/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 8,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 385525,
    title: 'Paris: Louvre Virtual Tour with Art Historian',
    url: 'https://www.getyourguide.com/paris-l16/paris-louvre-virtual-tour-with-art-historian-t385525/',
    price: {
      original: '€ 15',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433052-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433052-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433052-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433052-53.jpg',
    smallDescription: 'Join a licensed art historian on a fully interactive virtual tour of the Louvre Museum filled with photos, videos, polls, and a live Q&A.',
    description: 'Join a licensed art historian on a fully interactive virtual tour of the Louvre Museum filled with photos, videos, polls, and a live Q&amp;A.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433052-68.jpg',
    imageAlt: 'paris louvre virtual tour with art historian',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 2,
    totalRatingTitle: '2 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 9,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-louvre-virtual-tour-with-art-historian-t385525/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Thursday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 9,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 21170,
    title: 'Montparnasse Tower Roof Terrace Ticket: 360 degrees of Paris',
    url: 'https://www.getyourguide.com/paris-l16/montparnasse-tower-roof-terrace-ticket-360-degrees-of-paris-t21170/',
    price: {
      original: '€ 18',
      min: '€ 18',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1769112-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1769112-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1769112-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1769112-53.jpg',
    smallDescription: "You don't need wings to have a stunning 360-degree bird's-eye view of Paris, including the Eiffel Tower. All you need is a ticket to the roof terrace…",
    description: 'You don&#039;t need wings to have a stunning 360-degree bird&#039;s-eye view of Paris, including the Eiffel Tower. All you need is a ticket to the roof terrace of the Montparnasse Tower.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1769112-68.jpg',
    imageAlt: 'montparnasse tower roof terrace ticket 360 degrees of paris',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 2475,
    totalRatingTitle: '2475 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 10,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/montparnasse-tower-roof-terrace-ticket-360-degrees-of-paris-t21170/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 18 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 10,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 49746,
    title: 'Paris Museum Pass: 2, 4, or 6 Days',
    url: 'https://www.getyourguide.com/paris-l16/paris-museum-pass-t49746/',
    price: {
      original: '€ 57',
      min: '€ 57',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-308563-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-308563-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-308563-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-308563-53.jpg',
    smallDescription: 'Visit more than 60 of the top museums and monuments in and around Paris with a convenient and affordable Paris Museum Pass. Explore the Louvre and…',
    description: 'Visit more than 60 of the top museums and monuments in and around Paris with a convenient and affordable Paris Museum Pass. Explore the Louvre and Versailles, and visit the Arc de Triomphe, the Centre Pompidou, and many others.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-308563-68.jpg',
    imageAlt: 'paris museum pass 2 4 or 6 days',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 1261,
    totalRatingTitle: '1261 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '2 - 6 days',
    validFrom: 'time_activated',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 11,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-museum-pass-t49746/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 57 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 11,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 3633,
    title: 'Opera Garnier Tour with Expert Guides in Paris',
    url: 'https://www.getyourguide.com/paris-l16/opera-garnier-tour-with-expert-guides-in-paris-t3633/',
    price: {
      original: '€ 17',
      min: '€ 17',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-657876-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-657876-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-657876-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-657876-53.jpg',
    smallDescription: "Discover Europe's largest opera house on an informative 90-minute tour of the Opera Garnier. Knowledgeable and enthusiastic guides from the Opera de…",
    description: 'Discover Europe&#039;s largest opera house on an informative 90-minute tour of the Opera Garnier. Knowledgeable and enthusiastic guides from the Opera de Paris will uncover the secrets of this Baroque masterpiece, located in the heart of Paris.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      35,
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-657876-68.jpg',
    imageAlt: 'opera garnier tour with expert guides in paris',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 3297,
    totalRatingTitle: '3297 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 12,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/opera-garnier-tour-with-expert-guides-in-paris-t3633/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/06/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 17 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 12,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 125360,
    title: 'Paris: Eiffel Tower Stair Climb to Floor 2 w/ Summit Option',
    url: 'https://www.getyourguide.com/paris-l16/eiffel-tower-climbing-experience-t125360/',
    price: {
      original: '€ 34',
      min: '€ 34',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2215792-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2215792-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2215792-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2215792-53.jpg',
    smallDescription: 'Take the challenge of climbing 704 steps to the 2nd floor of the Eiffel Tower and be rewarded with the most spectacular views of Paris. Learn the…',
    description: 'Take the challenge of climbing 704 steps to the 2nd floor of the Eiffel Tower and be rewarded with the most spectacular views of Paris. Learn the structure’s history from your expert guide. Upgrade when booking for access to the summit.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2215792-68.jpg',
    imageAlt: 'paris eiffel tower stair climb to floor 2 w/ summit option',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.7',
    maxPossibleRating: 5,
    totalRating: 3698,
    totalRatingTitle: '3698 Reviews',
    averageRatingClass: '35',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 - 2.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 13,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/eiffel-tower-climbing-experience-t125360/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 34 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 13,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 59528,
    title: 'Palace of Versailles: Entry Ticket with Audio Guide',
    url: 'https://www.getyourguide.com/paris-l16/palace-of-versailles-entrance-ticket-t59528/',
    price: {
      original: '€ 18',
      min: '€ 18',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-411296-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-411296-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-411296-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-411296-53.jpg',
    smallDescription: 'Discover the center of political power in France before the French Revolution. See the palace, discover the décor of the “Sun King” in the Hall of…',
    description: 'Discover the center of political power in France before the French Revolution. See the palace, discover the décor of the “Sun King” in the Hall of Mirrors, and stroll through the palace gardens (in high season).',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      87,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-411296-68.jpg',
    imageAlt: 'palace of versailles entry ticket with audio guide',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.0',
    maxPossibleRating: 5,
    totalRating: 1392,
    totalRatingTitle: '1392 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.0 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 14,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/palace-of-versailles-entrance-ticket-t59528/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 18 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 14,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 70627,
    title: 'Les Invalides: Napoleon&#039;s Tomb &amp; Army Museum Priority Entry',
    url: 'https://www.getyourguide.com/paris-l16/paris-full-day-military-history-art-collection-tour-t70627/',
    price: {
      original: '€ 12',
      min: '€ 12',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1514326-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1514326-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1514326-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1514326-53.jpg',
    smallDescription: "The Army Museum — Hôtel National des Invalides — is home to one of the world's largest military history and art collections and provides a unique…",
    description: 'The Army Museum — Hôtel National des Invalides — is home to one of the world&#039;s largest military history and art collections and provides a unique overview of the history of France. Explore its permanent collections, the Dome Church and Napoleon&#039;s Tomb.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1514326-68.jpg',
    imageAlt: 'les invalides napoleons tomb army museum priority entry',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 1136,
    totalRatingTitle: '1136 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 15,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-full-day-military-history-art-collection-tour-t70627/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 12 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 15,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 4059,
    title: 'Paris Hop-on Hop-off Bus Tour: Classic, Premium or Deluxe',
    url: 'https://www.getyourguide.com/paris-l16/paris-hop-on-hop-off-tour-1-and-2-day-ticket-t4059/',
    price: {
      original: '€ 39',
      min: '€ 33.15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2432265-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2432265-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2432265-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2432265-53.jpg',
    smallDescription: 'Tour the enchanting city of Paris at your own pace, on an open-top double-decker sightseeing bus. You can hop-on and off as often as you like on 2…',
    description: 'Tour the enchanting city of Paris at your own pace, on an open-top double-decker sightseeing bus. You can hop-on and off as often as you like on 2 routes, taking in the best that the City of Light has to offer.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      93,
      6,
      56,
      88,
      64,
    ],
    hasDeal: true,
    dealMaxPercentage: 15,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2432265-68.jpg',
    imageAlt: 'paris hopon hopoff bus tour classic premium or deluxe',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 1909,
    totalRatingTitle: '1909 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 - 2 days',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 16,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-hop-on-hop-off-tour-1-and-2-day-ticket-t4059/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 33 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 16,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 53306,
    title: 'Paris: 3-Course Dinner Cruise on the Seine River',
    url: 'https://www.getyourguide.com/paris-l16/paris-3-course-dinner-cruise-on-the-river-seine-t53306/',
    price: {
      original: '€ 61',
      min: '€ 61',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2968186-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2968186-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2968186-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2968186-53.jpg',
    smallDescription: 'Experience the beauty of Paris in the evening from the River Seine as you cruise past iconic landmarks, and enjoy a 3-course dinner on board.',
    description: 'Experience the beauty of Paris in the evening from the River Seine as you cruise past iconic landmarks, and enjoy a 3-course dinner on board.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2968186-68.jpg',
    imageAlt: 'paris 3course dinner cruise on the seine river',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 846,
    totalRatingTitle: '846 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes - 2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 17,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-3-course-dinner-cruise-on-the-river-seine-t53306/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 09/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 61 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 17,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 103484,
    title: 'Paris: Orsay and Orangerie Museums Skip-the-Line Ticket',
    url: 'https://www.getyourguide.com/paris-l16/orsay-orangerie-museums-combination-skip-the-line-ticket-t103484/',
    price: {
      original: '€ 22',
      min: '€ 22',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-708427-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-708427-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-708427-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-708427-53.jpg',
    smallDescription: 'See masterpieces of art with a combined entry ticket to both the Orsay Museum and Orangerie Museum in the heart of Paris. Skip the long lines at both…',
    description: 'See masterpieces of art with a combined entry ticket to both the Orsay Museum and Orangerie Museum in the heart of Paris. Skip the long lines at both venues to marvel at sculptures and paintings, including Monet&#039;s legendary &quot;Water Lilies&quot; cycle.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-708427-68.jpg',
    imageAlt: 'paris orsay and orangerie museums skiptheline ticket',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 809,
    totalRatingTitle: '809 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '60 days',
    validFrom: 'time_activated',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 18,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/orsay-orangerie-museums-combination-skip-the-line-ticket-t103484/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 22 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 18,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 249207,
    title: 'Paris: Paris Saint-Germain Parc des Princes Stadium Tour',
    url: 'https://www.getyourguide.com/paris-l16/parc-des-princes-stadium-tour-t249207/',
    price: {
      original: '€ 27.50',
      min: '€ 27.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2324787-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2324787-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2324787-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2324787-53.jpg',
    smallDescription: "Discover the stadium's backstage, stroll through the dressing rooms, see the changing rooms, and even sit on the substitute bench.",
    description: 'Discover the stadium&#039;s backstage, stroll through the dressing rooms, see the changing rooms, and even sit on the substitute bench.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      6,
      23,
      29,
      35,
      39,
      55,
      56,
      88,
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2324787-68.jpg',
    imageAlt: 'paris paris saintgermain parc des princes stadium tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 237,
    totalRatingTitle: '237 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 19,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/parc-des-princes-stadium-tour-t249207/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/11/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 28 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 19,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 56388,
    title: 'Versailles Palace &amp; Gardens Timed Ticket with Audio Guide',
    url: 'https://www.getyourguide.com/paris-l16/versailles-skip-the-line-ticket-and-audio-tour-t56388/',
    price: {
      original: '€ 32',
      min: '€ 32',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740892-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740892-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740892-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740892-53.jpg',
    smallDescription: 'Enjoy a self-guided tour of Versailles Palace with an audio guide. Marvel at the ornate State Apartments of Louis XIV and Marie Antoinette, and the…',
    description: 'Enjoy a self-guided tour of Versailles Palace with an audio guide. Marvel at the ornate State Apartments of Louis XIV and Marie Antoinette, and the breathtaking Hall of Mirrors. Stroll through the gardens after your tour for as long as you like.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      56,
      87,
      88,
      93,
      64,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740892-68.jpg',
    imageAlt: 'versailles palace gardens timed ticket with audio guide',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 4528,
    totalRatingTitle: '4528 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 20,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/versailles-skip-the-line-ticket-and-audio-tour-t56388/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/30/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 32 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 20,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 48868,
    title: 'Paris Louvre Museum: Priority Entrance with Audio Guide',
    url: 'https://www.getyourguide.com/paris-l16/louvre-museum-ticket-with-audio-guide-t48868/',
    price: {
      original: '€ 39',
      min: '€ 39',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740571-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740571-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740571-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740571-53.jpg',
    smallDescription: 'Make the most of the Louvre with skip-the-line admission and a custom-made 2-hour itinerary with an audio guide. Wander around the fascinating…',
    description: 'Make the most of the Louvre with skip-the-line admission and a custom-made 2-hour itinerary with an audio guide. Wander around the fascinating exhibitions at your own pace and marvel at world-famous works such as Leonardo da Vinci&#039;s Mona Lisa.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      35,
      39,
      55,
      56,
      88,
      93,
      23,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1740571-68.jpg',
    imageAlt: 'paris louvre museum priority entrance with audio guide',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.4',
    maxPossibleRating: 5,
    totalRating: 2011,
    totalRatingTitle: '2011 Reviews',
    averageRatingClass: '35',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.4 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 21,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/louvre-museum-ticket-with-audio-guide-t48868/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 09/02/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 39 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 21,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 69880,
    title: 'Legendary Stade de France: Behind the Scenes Tour',
    url: 'https://www.getyourguide.com/paris-l16/stade-de-france-legendary-behind-the-scenes-tour-t69880/',
    price: {
      original: '€ 15',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-464121-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-464121-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-464121-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-464121-53.jpg',
    smallDescription: 'Step into France’s largest football stadium, host to the finals of the FIFA World Cup in 1998 and the UEFA Euro Cup in 2016. Go behind the scenes and…',
    description: 'Step into France’s largest football stadium, host to the finals of the FIFA World Cup in 1998 and the UEFA Euro Cup in 2016. Go behind the scenes and learn about the architecture, walk in private areas and finish your visit at the museum.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      35,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-464121-68.jpg',
    imageAlt: 'legendary stade de france behind the scenes tour',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 876,
    totalRatingTitle: '876 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 22,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/stade-de-france-legendary-behind-the-scenes-tour-t69880/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 22,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 65092,
    title: 'Center Pompidou: Priority Ticket to Permanent Collections',
    url: 'https://www.getyourguide.com/paris-l16/pompidou-center-skip-the-line-tickets-t65092/',
    price: {
      original: '€ 14',
      min: '€ 14',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661602-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661602-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661602-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661602-53.jpg',
    smallDescription: 'The Centre Pompidou houses the richest National Modern Art Museum in Europe and is often referred to as the European MOMA. Access this contemporary…',
    description: 'The Centre Pompidou houses the richest National Modern Art Museum in Europe and is often referred to as the European MOMA. Access this contemporary building, located in the heart of Paris.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-661602-68.jpg',
    imageAlt: 'center pompidou priority ticket to permanent collections',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 1042,
    totalRatingTitle: '1042 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 23,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/pompidou-center-skip-the-line-tickets-t65092/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 09/02/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 14 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 23,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 2907,
    title: 'Paris: Grévin Wax Museum Ticket',
    url: 'https://www.getyourguide.com/paris-l16/grvin-wax-museum-tour-t2907/',
    price: {
      original: '€ 24.50',
      min: '€ 24.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1668315-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1668315-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1668315-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1668315-53.jpg',
    smallDescription: 'See your favorite artists and personalities in original life-like wax figures at the historic Grévin Wax Museum in Paris. Sing with Michael Jackson,…',
    description: 'See your favorite artists and personalities in original life-like wax figures at the historic Grévin Wax Museum in Paris. Sing with Michael Jackson, take a picture with Monica Bellucci, and say hello to Barack Obama and George Clooney!',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1668315-68.jpg',
    imageAlt: 'paris grévin wax museum ticket',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 1370,
    totalRatingTitle: '1370 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 24,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/grvin-wax-museum-tour-t2907/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 25 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 24,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 24909,
    title: 'Versailles Palace &amp; Gardens: Ticket, Audio Guide &amp; Transfer',
    url: 'https://www.getyourguide.com/paris-l16/skip-the-line-versailles-palace-and-gardens-half-day-tour-t24909/',
    price: {
      original: '€ 59',
      min: '€ 59',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2375315-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2375315-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2375315-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2375315-53.jpg',
    smallDescription: 'Travel by air-conditioned bus from Paris, skip the long lines and enjoy a self-guided audio tour of the palace. After, explore the beautiful gardens…',
    description: 'Travel by air-conditioned bus from Paris, skip the long lines and enjoy a self-guided audio tour of the palace. After, explore the beautiful gardens with the Grand and Petit Trianon, and the Estate of Marie Antoinette.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      39,
      88,
      93,
      23,
      35,
      55,
      56,
      87,
      143,
      64,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2375315-68.jpg',
    imageAlt: 'versailles palace gardens ticket audio guide transfer',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 801,
    totalRatingTitle: '801 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours - 1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 25,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/skip-the-line-versailles-palace-and-gardens-half-day-tour-t24909/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/16/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 59 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 25,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 47874,
    title: 'A Day in Paris: Louvre Reserved Access and 1-hour Cruise',
    url: 'https://www.getyourguide.com/paris-l16/1-day-in-paris-1-museum-cruise-metro-tickets-map-t47874/',
    price: {
      original: '€ 45',
      min: '€ 45',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-290069-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-290069-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-290069-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-290069-53.jpg',
    smallDescription: 'Create your own perfect day in Paris with a reserved entrance to the Louvre Museum, and a cruise on the River Seine to experience the city from its…',
    description: 'Create your own perfect day in Paris with a reserved entrance to the Louvre Museum, and a cruise on the River Seine to experience the city from its historic waterway.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-290069-68.jpg',
    imageAlt: 'a day in paris louvre reserved access and 1hour cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 135,
    totalRatingTitle: '135 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 26,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/1-day-in-paris-1-museum-cruise-metro-tickets-map-t47874/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/15/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 45 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 26,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 199630,
    title: 'Paris: Pere Lachaise Cemetery Guided Tour in French',
    url: 'https://www.getyourguide.com/paris-l16/paris-pere-lachaise-cemetery-guided-tour-in-french-t199630/',
    price: {
      original: '€ 12',
      min: '€ 12',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1518289-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1518289-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1518289-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1518289-53.jpg',
    smallDescription: 'Explore the funerary art of the legendary Père Lachaise Cemetery of Paris with a 2.5-hour guided tour. Admire the graves of Marcel Proust, Honoré de…',
    description: 'Explore the funerary art of the legendary Père Lachaise Cemetery of Paris with a 2.5-hour guided tour. Admire the graves of Marcel Proust, Honoré de Balzac, Edith Piaf, Jim Morrison, Chopin and many other artists, writers, and musicians.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      35,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1518289-68.jpg',
    imageAlt: 'paris pere lachaise cemetery guided tour in french',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 269,
    totalRatingTitle: '269 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 27,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-pere-lachaise-cemetery-guided-tour-in-french-t199630/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/06/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 12 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 27,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 66215,
    title: 'Sainte-Chapelle &amp; Conciergerie Combined Skip-the-Line Ticket',
    url: 'https://www.getyourguide.com/paris-l16/sainte-chapelle-and-conciergerie-combined-ticket-t66215/',
    price: {
      original: '€ 17',
      min: '€ 17',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661707-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661707-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661707-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661707-53.jpg',
    smallDescription: 'Take advantage of a combination ticket that grants you access to Sainte-Chapelle and the Conciergerie. Dive into the architectural beauty and rich…',
    description: 'Take advantage of a combination ticket that grants you access to Sainte-Chapelle and the Conciergerie. Dive into the architectural beauty and rich cultural history of these two unique sites.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      28,
      29,
      35,
      39,
      55,
      56,
      87,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-661707-68.jpg',
    imageAlt: 'saintechapelle conciergerie combined skiptheline ticket',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 1172,
    totalRatingTitle: '1172 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours - 1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 28,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/sainte-chapelle-and-conciergerie-combined-ticket-t66215/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/22/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 17 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 28,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 179570,
    title: 'Paris: 3-course Dinner Cruise with Panorama on Seine River',
    url: 'https://www.getyourguide.com/paris-l16/paris-dinner-cruise-t179570/',
    price: {
      original: '€ 42',
      min: '€ 42',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1308641-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1308641-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1308641-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1308641-53.jpg',
    smallDescription: 'Inaugurated in July 2009, the Paris en Scène floating restaurant offers you a dinner cruise with a starter, main course, and dessert.',
    description: 'Inaugurated in July 2009, the Paris en Scène floating restaurant offers you a dinner cruise with a starter, main course, and dessert.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      35,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1308641-68.jpg',
    imageAlt: 'paris 3course dinner cruise with panorama on seine river',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.9',
    maxPossibleRating: 5,
    totalRating: 594,
    totalRatingTitle: '594 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1.15 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 29,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-dinner-cruise-t179570/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 42 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 29,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 43835,
    title: 'Paris: Crazy Horse Cabaret Show',
    url: 'https://www.getyourguide.com/paris-l16/crazy-horse-show-t43835/',
    price: {
      original: '€ 87',
      min: '€ 87',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-940485-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-940485-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-940485-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-940485-53.jpg',
    smallDescription: "Let yourself be seduced by the subtle light effects of a show that's bewitched audiences since 1951. Discover the glamor and impertinence that are…",
    description: 'Let yourself be seduced by the subtle light effects of a show that&#039;s bewitched audiences since 1951. Discover the glamor and impertinence that are the very DNA of Crazy Horse Paris in the immersive format of &quot;Totally Crazy.&quot;',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-940485-68.jpg',
    imageAlt: 'paris crazy horse cabaret show',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 285,
    totalRatingTitle: '285 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes - 3 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 30,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/crazy-horse-show-t43835/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 87 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 30,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 51059,
    title: 'Paris: Evening Cruise with Dinner on River Seine',
    url: 'https://www.getyourguide.com/paris-l16/bateaux-parisiens-dinner-cruise-t51059/',
    price: {
      original: '€ 79',
      min: '€ 79',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2345100-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2345100-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2345100-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2345100-53.jpg',
    smallDescription: 'Enjoy an à-la-carte dinner on-board whilst cruising on River Seine. Discover the City of Lights from the water and see the iconic monuments of Paris…',
    description: 'Enjoy an à-la-carte dinner on-board whilst cruising on River Seine. Discover the City of Lights from the water and see the iconic monuments of Paris illuminated.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2345100-68.jpg',
    imageAlt: 'paris evening cruise with dinner on river seine',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 1348,
    totalRatingTitle: '1348 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '75 minutes - 2.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 31,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/bateaux-parisiens-dinner-cruise-t51059/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 79 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 31,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 105532,
    title: 'Behind the Scenes of the Grand Rex: 50-Minute Studio Tour',
    url: 'https://www.getyourguide.com/paris-l16/rex-studios-tour-behind-the-scenes-of-the-grand-rex-t105532/',
    price: {
      original: '€ 11',
      min: '€ 11',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1705398-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1705398-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1705398-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1705398-53.jpg',
    smallDescription: 'Enjoy a unique and interactive visit to the Rex Studios in Paris and experience the magical world of cinema. See the backstage area, archived images,…',
    description: 'Enjoy a unique and interactive visit to the Rex Studios in Paris and experience the magical world of cinema. See the backstage area, archived images, film sets, special effects, tricks and more. Admire the building’s original décor from 1932.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      35,
      39,
      55,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1705398-68.jpg',
    imageAlt: 'behind the scenes of the grand rex 50minute studio tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 300,
    totalRatingTitle: '300 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '50 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 32,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/rex-studios-tour-behind-the-scenes-of-the-grand-rex-t105532/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 11 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 32,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 91890,
    title: 'Paris: Eiffel Tower Guided Climb with Optional Summit Access',
    url: 'https://www.getyourguide.com/paris-l16/paris-2-hours-guided-climb-of-eiffel-tower-skip-lines-t91890/',
    price: {
      original: '€ 34',
      min: '€ 34',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2354830-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2354830-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2354830-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2354830-53.jpg',
    smallDescription: 'Avoid the long elevator lines at the Eiffel Tower and climb the stairs to the 2nd level with a guide. Enjoy rest stops to take in the view and hear…',
    description: 'Avoid the long elevator lines at the Eiffel Tower and climb the stairs to the 2nd level with a guide. Enjoy rest stops to take in the view and hear stories along the way.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2354830-68.jpg',
    imageAlt: 'paris eiffel tower guided climb with optional summit access',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 1976,
    totalRatingTitle: '1976 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 33,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-2-hours-guided-climb-of-eiffel-tower-skip-lines-t91890/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 09/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 34 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 33,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 53090,
    title: 'Paris: Lido Cabaret Show With Champagne',
    url: 'https://www.getyourguide.com/paris-l16/paris-le-lido-show-paris-merveilles-and-champagne-t53090/',
    price: {
      original: '€ 85',
      min: '€ 72.25',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3409571-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3409571-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3409571-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3409571-53.jpg',
    smallDescription: 'Spend an evening at the Lido in Paris, enthralled by the Paris Merveilles show! Marvel at the precision and the energy of the dancing of the Bluebell…',
    description: 'Spend an evening at the Lido in Paris, enthralled by the Paris Merveilles show! Marvel at the precision and the energy of the dancing of the Bluebell Girls and the Lido Boys, and their stunning costumes, as you enjoy a half bottle of Champagne.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: true,
    dealMaxPercentage: 15,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3409571-68.jpg',
    imageAlt: 'paris lido cabaret show with champagne',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 929,
    totalRatingTitle: '929 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 34,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-le-lido-show-paris-merveilles-and-champagne-t53090/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 72 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 34,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 70680,
    title: 'Paris: Panthéon Admission Ticket and Self-Guided Tour',
    url: 'https://www.getyourguide.com/paris-l16/paris-self-guided-tour-of-the-panthon-ticket-t70680/',
    price: {
      original: '€ 11.50',
      min: '€ 11.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-500272-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-500272-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-500272-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-500272-53.jpg',
    smallDescription: 'Explore the Panthéon, the temple dedicated to the memory of the men and women who have marked French history since the time of the French Revolution.…',
    description: 'Explore the Panthéon, the temple dedicated to the memory of the men and women who have marked French history since the time of the French Revolution. Spend a fascinating hour on a self-guided tour and take in views of the city from the upper floors.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      29,
      35,
      39,
      55,
      87,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-500272-68.jpg',
    imageAlt: 'paris panthéon admission ticket and selfguided tour',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 477,
    totalRatingTitle: '477 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 35,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-self-guided-tour-of-the-panthon-ticket-t70680/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/22/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 12 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 35,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 168029,
    title: 'Paris: Bastille Day Dinner Cruise',
    url: 'https://www.getyourguide.com/paris-l16/bastille-day-dinner-cruise-t168029/',
    price: {
      original: '€ 155',
      min: '€ 155',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1210682-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1210682-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1210682-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1210682-53.jpg',
    smallDescription: 'Experience the French Bastille Day dinner cruise along the Seine River aboard a totally modern glass canopy boat where you will enjoy the illuminated…',
    description: 'Experience the French Bastille Day dinner cruise along the Seine River aboard a totally modern glass canopy boat where you will enjoy the illuminated bridges and monuments and taste a 6-course meal with wine and Champagne.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      29,
      35,
      109,
      39,
      55,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1210682-68.jpg',
    imageAlt: 'paris bastille day dinner cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 1,
    totalRatingTitle: '1 Review',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 36,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/bastille-day-dinner-cruise-t168029/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/14/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 155 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 36,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 385514,
    title: 'Paris: Catacombs Virtual Tour with French History Expert',
    url: 'https://www.getyourguide.com/paris-l16/paris-catacombs-virtual-tour-with-french-history-expert-t385514/',
    price: {
      original: '€ 15',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433059-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433059-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433059-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433059-53.jpg',
    smallDescription: 'Join a licensed historian on a fully interactive virtual tour of the Catacombs of Paris filled with photos, videos, polls, and a live Q&A.',
    description: 'Join a licensed historian on a fully interactive virtual tour of the Catacombs of Paris filled with photos, videos, polls, and a live Q&amp;A.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3433059-68.jpg',
    imageAlt: 'paris catacombs virtual tour with french history expert',
    isFreeCancellation: true,
    hasRating: false,
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 37,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-catacombs-virtual-tour-with-french-history-expert-t385514/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Sunday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 37,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 46877,
    title: 'Roissy CDG and Orly Shared Minivan Transfers',
    url: 'https://www.getyourguide.com/paris-l16/paris-airports-shared-minivan-transfer-t46877/',
    price: {
      original: '€ 18.75',
      min: '€ 18.75',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-280720-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-280720-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-280720-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-280720-53.jpg',
    smallDescription: 'Take the worry out of your transportation needs on arrival or departure from Paris and pre-book a shared transfer from or to either Charles de Gaulle…',
    description: 'Take the worry out of your transportation needs on arrival or departure from Paris and pre-book a shared transfer from or to either Charles de Gaulle Airport or Orly Airport. Relax in comfort and save time and money on expensive local taxis.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-280720-68.jpg',
    imageAlt: 'roissy cdg and orly shared minivan transfers',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.8',
    maxPossibleRating: 5,
    totalRating: 1785,
    totalRatingTitle: '1785 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 38,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-airports-shared-minivan-transfer-t46877/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 19 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 38,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 189477,
    title: 'Paris: Moulin Rouge Show with Champagne',
    url: 'https://www.getyourguide.com/paris-l16/moulin-rouge-show-with-champagne-t189477/',
    price: {
      original: '€ 90',
      min: '€ 90',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1396968-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1396968-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1396968-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1396968-53.jpg',
    smallDescription: 'Revel in the sumptuous settings of the Moulin Rouge, the world-renowned cabaret in Paris, with a ticket to the spectacular show "Féerie". Sip on…',
    description: 'Revel in the sumptuous settings of the Moulin Rouge, the world-renowned cabaret in Paris, with a ticket to the spectacular show &quot;Féerie&quot;. Sip on sparkling Champagne as you savor international performances filled to the brim with feathers and rhinestones.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1396968-68.jpg',
    imageAlt: 'paris moulin rouge show with champagne',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 3102,
    totalRatingTitle: '3102 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 39,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/moulin-rouge-show-with-champagne-t189477/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 08/31/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 90 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 39,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 42092,
    title: 'Paris: Mysteries of the Opera Garnier After Hours Tour',
    url: 'https://www.getyourguide.com/paris-l16/mysteries-of-the-opera-garnier-after-hours-tour-t42092/',
    price: {
      original: '€ 21',
      min: '€ 21',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-901470-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-901470-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-901470-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-901470-53.jpg',
    smallDescription: 'Uncover the mysteries of the Opera Garnier in Paris on a 90-minute tour of the public areas in English or French. See stunning gilt and mosaic…',
    description: 'Uncover the mysteries of the Opera Garnier in Paris on a 90-minute tour of the public areas in English or French. See stunning gilt and mosaic decorations, lose yourself in the labyrinth of corridors, and learn about some of the legendary performances.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-901470-68.jpg',
    imageAlt: 'paris mysteries of the opera garnier after hours tour',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 198,
    totalRatingTitle: '198 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 40,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/mysteries-of-the-opera-garnier-after-hours-tour-t42092/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/04/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 21 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 40,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 177429,
    title: 'Paris: Eiffel Tower Summit Access with Tour',
    url: 'https://www.getyourguide.com/paris-l16/eiffel-tower-summit-tour-by-elevator-t177429/',
    price: {
      original: '€ 60',
      min: '€ 60',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1737304-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1737304-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1737304-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1737304-53.jpg',
    smallDescription: 'Join your expert guide for a ride up the Eiffel Tower. Along the way, hear stories and fun facts about the Tower and the surrounding landmarks.',
    description: 'Join your expert guide for a ride up the Eiffel Tower. Along the way, hear stories and fun facts about the Tower and the surrounding landmarks.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1737304-68.jpg',
    imageAlt: 'paris eiffel tower summit access with tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 960,
    totalRatingTitle: '960 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 41,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/eiffel-tower-summit-tour-by-elevator-t177429/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 09/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 60 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 41,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 308048,
    title: 'Paris: Italian Dinner Cruise on the River Seine',
    url: 'https://www.getyourguide.com/paris-l16/paris-seine-river-pizza-dinner-cruise-t308048/',
    price: {
      original: '€ 39',
      min: '€ 39',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2562828-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2562828-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2562828-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2562828-53.jpg',
    smallDescription: 'Embark on an Italian dinner cruise on the River Seine. Enjoy a hearty meal as you pass by the famous monuments of Paris.',
    description: 'Embark on an Italian dinner cruise on the River Seine. Enjoy a hearty meal as you pass by the famous monuments of Paris.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2562828-68.jpg',
    imageAlt: 'paris italian dinner cruise on the river seine',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.0',
    maxPossibleRating: 5,
    totalRating: 52,
    totalRatingTitle: '52 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '105 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 42,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-seine-river-pizza-dinner-cruise-t308048/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 08/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 39 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 42,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 176655,
    title: 'Paris: 1-Hour Cruise with French Food',
    url: 'https://www.getyourguide.com/paris-l16/paris-1-hour-cruise-with-a-crpe-t176655/',
    price: {
      original: '€ 20',
      min: '€ 20',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1284309-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1284309-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1284309-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1284309-53.jpg',
    smallDescription: 'Experience Paris from its historic waterway on a 1-hour Seine River cruise. Take a break and enjoy a French crepe or muffin with a soft drink as you…',
    description: 'Experience Paris from its historic waterway on a 1-hour Seine River cruise. Take a break and enjoy a French crepe or muffin with a soft drink as you listen to on-board audio commentary.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1284309-68.jpg',
    imageAlt: 'paris 1hour cruise with french food',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.9',
    maxPossibleRating: 5,
    totalRating: 311,
    totalRatingTitle: '311 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '60 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 43,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-1-hour-cruise-with-a-crpe-t176655/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 20 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 43,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 370091,
    title: 'Paris: Private Transfer between Paris &amp; CDG Airport',
    url: 'https://www.getyourguide.com/paris-l16/paris-private-transfer-between-paris-cdg-airport-t370091/',
    price: {
      original: '€ 62',
      min: '€ 62',
      type: 'group',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3213006-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3213006-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3213006-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3213006-53.jpg',
    smallDescription: 'Enjoy a convenient private ride between Charles De Gaulle Airport and your accommodation Paris. Choose this comfortable value-for-money option which…',
    description: 'Enjoy a convenient private ride between Charles De Gaulle Airport and your accommodation Paris. Choose this comfortable value-for-money option which is available day and night. Take a seat and let your driver take care of you during the transfer.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3213006-68.jpg',
    imageAlt: 'paris private transfer between paris cdg airport',
    isFreeCancellation: true,
    hasRating: false,
    hasDuration: true,
    useValidity: false,
    duration: '35 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 44,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-private-transfer-between-paris-cdg-airport-t370091/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available today and tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 62 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 44,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 149861,
    title: 'Paris: Eiffel Tower Direct Access with Summit Access',
    url: 'https://www.getyourguide.com/paris-l16/skip-the-line-ticket-to-the-summit-of-the-eiffel-tower-t149861/',
    price: {
      original: '€ 79.99',
      min: '€ 79.99',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2354735-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2354735-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2354735-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2354735-53.jpg',
    smallDescription: 'Visit the Eiffel Tower with a direct access ticket. Enjoy access to the 1st and 2nd floors and the Summit by elevator. Marvel at spectacular views of…',
    description: 'Visit the Eiffel Tower with a direct access ticket. Enjoy access to the 1st and 2nd floors and the Summit by elevator. Marvel at spectacular views of Paris.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2354735-68.jpg',
    imageAlt: 'paris eiffel tower direct access with summit access',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 1437,
    totalRatingTitle: '1437 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 45,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/skip-the-line-ticket-to-the-summit-of-the-eiffel-tower-t149861/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/25/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 80 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 45,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 184892,
    title: 'Eiffel Tower Guided Climb in German w/Optional Summit Access',
    url: 'https://www.getyourguide.com/paris-l16/eiffel-tower-guided-climb-in-german-woptional-summit-access-t184892/',
    price: {
      original: '€ 34',
      min: '€ 34',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1357400-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1357400-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1357400-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1357400-53.jpg',
    smallDescription: 'Avoid the long elevator lines at the Eiffel Tower and climb the stairs to the 2nd level with a German-speaking guide. Listen to stories about the…',
    description: 'Avoid the long elevator lines at the Eiffel Tower and climb the stairs to the 2nd level with a German-speaking guide. Listen to stories about the monument and its designer as you ascend 704 steps, and benefit from the rest stops to take in the view.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      39,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1357400-68.jpg',
    imageAlt: 'eiffel tower guided climb in german w/optional summit access',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 371,
    totalRatingTitle: '371 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 46,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/eiffel-tower-guided-climb-in-german-woptional-summit-access-t184892/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 09/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 34 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 46,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 15928,
    title: 'Paris: River Cruise on the Seine',
    url: 'https://www.getyourguide.com/paris-l16/paris-sightseeing-river-cruise-t15928/',
    price: {
      original: '€ 17.01',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2772271-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2772271-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2772271-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2772271-53.jpg',
    smallDescription: "Enjoy a relaxing 1-hour Paris river cruise past the French capital's most spectacular landmarks. Escape the busy streets and listen to audio…",
    description: 'Enjoy a relaxing 1-hour Paris river cruise past the French capital&#039;s most spectacular landmarks. Escape the busy streets and listen to audio commentary as you peacefully sail down the Seine, past Paris&#039;s iconic sights such as The Louvre and Eiffel Tower.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: true,
    dealMaxPercentage: 11.819999999999993,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2772271-68.jpg',
    imageAlt: 'paris river cruise on the seine',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 570,
    totalRatingTitle: '570 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 47,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-sightseeing-river-cruise-t15928/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 47,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 5029,
    title: 'Paris: Montmartre 2-Hour Walking Tour',
    url: 'https://www.getyourguide.com/paris-l16/montmartre-district-tour-t5029/',
    price: {
      original: '€ 16',
      min: '€ 16',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2261992-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2261992-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2261992-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2261992-53.jpg',
    smallDescription: 'Explore the Montmartre neighborhood in Paris and discover a district that typifies all things quintessentially Parisian, from terrace cafés to…',
    description: 'Explore the Montmartre neighborhood in Paris and discover a district that typifies all things quintessentially Parisian, from terrace cafés to romping bars and clubs, and saucy can-can dancers to bourgeois apartments and narrow cobblestone streets.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
      35,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2261992-68.jpg',
    imageAlt: 'paris montmartre 2hour walking tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 909,
    totalRatingTitle: '909 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 48,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/montmartre-district-tour-t5029/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 16 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 48,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 112054,
    title: 'Château de Fontainebleau: Priority Entrance Ticket',
    url: 'https://www.getyourguide.com/paris-l16/chteau-de-fontainebleau-priority-entrance-ticket-t112054/',
    price: {
      original: '€ 12',
      min: '€ 12',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-759865-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-759865-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-759865-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-759865-53.jpg',
    smallDescription: 'Save time and enjoy priority entrance to the the Fontainebleau Castle, where several generations of French monarchs lived and ruled and which is now…',
    description: 'Save time and enjoy priority entrance to the the Fontainebleau Castle, where several generations of French monarchs lived and ruled and which is now a national museum and Unesco World Heritage Site.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-759865-68.jpg',
    imageAlt: 'château de fontainebleau priority entrance ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 172,
    totalRatingTitle: '172 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 49,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/chteau-de-fontainebleau-priority-entrance-ticket-t112054/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 12 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 49,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 253347,
    title: 'Paris: Paris Saint-Germain Experience Premium Pass',
    url: 'https://www.getyourguide.com/paris-l16/paris-paris-saint-germain-experience-premium-pass-t253347/',
    price: {
      original: '€ 37.50',
      min: '€ 37.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2324722-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2324722-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2324722-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2324722-53.jpg',
    smallDescription: "Get to know your favorite soccer team, Paris Saint-Germain, in a new way. Visit the famous Parc des Princes, relive the club's best moments, and…",
    description: 'Get to know your favorite soccer team, Paris Saint-Germain, in a new way. Visit the famous Parc des Princes, relive the club&#039;s best moments, and embark on a VR adventure through Paris. Bring the whole family for this one-of-a-kind experience.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2324722-68.jpg',
    imageAlt: 'paris paris saintgermain experience premium pass',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 22,
    totalRatingTitle: '22 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 50,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-paris-saint-germain-experience-premium-pass-t253347/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/11/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 38 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 50,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 3461,
    title: 'Highlights of Paris: Private 6-Hour Vintage 2CV Tour',
    url: 'https://www.getyourguide.com/paris-l16/private-full-day-paris-tour-in-a-2cv-t3461/',
    price: {
      original: '€ 239.50',
      min: '€ 239.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-11189-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-11189-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-11189-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-11189-53.jpg',
    smallDescription: 'Visit the monuments, museums, and gardens of Paris on a private tour. Cruise the city’s streets in a vintage Citroen 2CV, and experience the city’s…',
    description: 'Visit the monuments, museums, and gardens of Paris on a private tour. Cruise the city’s streets in a vintage Citroen 2CV, and experience the city’s unique atmosphere. Tour the museum at the Arc de Triomphe and enjoy a traditional French lunch.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      35,
      39,
      55,
      109,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-11189-68.jpg',
    imageAlt: 'highlights of paris private 6hour vintage 2cv tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 7,
    totalRatingTitle: '7 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '6 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 51,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/private-full-day-paris-tour-in-a-2cv-t3461/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 240 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 51,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 153564,
    title: '&quot;Oh My God She&#039;s Parisian!&quot; Parisian Comedy Show in English',
    url: 'https://www.getyourguide.com/paris-l16/oh-my-god-she-s-parisianthe-parisian-comedy-100-in-english-t153564/',
    price: {
      original: '€ 24',
      min: '€ 24',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2901836-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2901836-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2901836-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2901836-53.jpg',
    smallDescription: 'See Paris’ only one-woman comedy show that’s 100% in English. Learn everything you need to know about how Parisians live from a real Parisian woman.…',
    description: 'See Paris’ only one-woman comedy show that’s 100% in English. Learn everything you need to know about how Parisians live from a real Parisian woman. Laugh as Julie Collas pulls back the curtain on the City of Love.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2901836-68.jpg',
    imageAlt: '&quot;oh my god shes parisian!&quot; parisian comedy show in english',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 23,
    totalRatingTitle: '23 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '65 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 52,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/oh-my-god-she-s-parisianthe-parisian-comedy-100-in-english-t153564/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/05/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 24 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 52,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 189480,
    title: 'Paris: Dinner Show at the Moulin Rouge',
    url: 'https://www.getyourguide.com/paris-l16/paris-moulin-rouge-show-t189480/',
    price: {
      original: '€ 190',
      min: '€ 190',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1397019-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1397019-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1397019-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1397019-53.jpg',
    smallDescription: 'Experience the fantastic atmosphere of the Moulin Rouge in Paris at a perfomance of the “Féerie” show, while enjoying a delicious dinner from a menu…',
    description: 'Experience the fantastic atmosphere of the Moulin Rouge in Paris at a perfomance of the “Féerie” show, while enjoying a delicious dinner from a menu of traditional French food, with vegetarian and vegan options.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1397019-68.jpg',
    imageAlt: 'paris dinner show at the moulin rouge',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 930,
    totalRatingTitle: '930 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '4 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 53,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-moulin-rouge-show-t189480/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 08/31/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 190 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 53,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 176649,
    title: 'Paris: Sunset Champagne Cruise',
    url: 'https://www.getyourguide.com/paris-l16/paris-sunset-champagne-cruise-t176649/',
    price: {
      original: '€ 21',
      min: '€ 21',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2772211-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2772211-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2772211-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2772211-53.jpg',
    smallDescription: 'Experience Paris from its historic waterway on a 1-hour Seine River cruise. Sip a glass of Champagne with your lover or friends as you listen to…',
    description: 'Experience Paris from its historic waterway on a 1-hour Seine River cruise. Sip a glass of Champagne with your lover or friends as you listen to on-board audio commentary.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2772211-68.jpg',
    imageAlt: 'paris sunset champagne cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.1',
    maxPossibleRating: 5,
    totalRating: 281,
    totalRatingTitle: '281 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.1 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '60 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 54,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-sunset-champagne-cruise-t176649/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 21 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 54,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 70689,
    title: 'Self-Guided Tour &amp; Skip-the-Line Ticket to Sainte Chapelle',
    url: 'https://www.getyourguide.com/paris-l16/sainte-chapelle-self-guided-tour-t70689/',
    price: {
      original: '€ 11.50',
      min: '€ 11.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-495242-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-495242-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-495242-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-495242-53.jpg',
    smallDescription: 'Take a self-guided tour and marvel at the more than 1,000 stained glass windows in this jewel of the Gothic period. Built in just 7 years, the Sainte…',
    description: 'Take a self-guided tour and marvel at the more than 1,000 stained glass windows in this jewel of the Gothic period. Built in just 7 years, the Sainte Chapelle was intended to house significant Christian relics, including Christ&#039;s Crown of Thorns.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      23,
      28,
      29,
      35,
      39,
      55,
      56,
      87,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-495242-68.jpg',
    imageAlt: 'selfguided tour skiptheline ticket to sainte chapelle',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 1962,
    totalRatingTitle: '1962 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 55,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/sainte-chapelle-self-guided-tour-t70689/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/22/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 12 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 55,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 24450,
    title: 'River Seine Cruise from Parc de la Villette',
    url: 'https://www.getyourguide.com/paris-l16/river-seine-canal-st-martin-morning-cruise-t24450/',
    price: {
      original: '€ 22',
      min: '€ 22',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-117709-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-117709-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-117709-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-117709-53.jpg',
    smallDescription: 'See Paris from the water on a 2.5-hour cruise of the River Seine and Canal Saint-Martin. Pass by the Notre-Dame Cathedral, and under the Bastille…',
    description: 'See Paris from the water on a 2.5-hour cruise of the River Seine and Canal Saint-Martin. Pass by the Notre-Dame Cathedral, and under the Bastille vault. Discover the romantic side of Paris on this cruise from Parc de la Villette to Musée d’Orsay.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      35,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-117709-68.jpg',
    imageAlt: 'river seine cruise from parc de la villette',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 660,
    totalRatingTitle: '660 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 56,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/river-seine-canal-st-martin-morning-cruise-t24450/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 22 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 56,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 387086,
    title: 'Paris: Montmartre Virtual Tour in German',
    url: 'https://www.getyourguide.com/paris-l16/paris-montmartre-virtual-tour-in-german-t387086/',
    price: {
      original: '€ 8',
      min: '€ 8',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3448696-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3448696-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3448696-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3448696-53.jpg',
    smallDescription: 'Discover the iconic Montmartre quarter from the comfort of your own home through a unique virtual tour led by a german speaking expert guide.',
    description: 'Discover the iconic Montmartre quarter from the comfort of your own home through a unique virtual tour led by a german speaking expert guide.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      39,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3448696-68.jpg',
    imageAlt: 'paris montmartre virtual tour in german',
    isFreeCancellation: true,
    hasRating: false,
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 57,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-montmartre-virtual-tour-in-german-t387086/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Thursday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 8 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 57,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 38938,
    title: 'Paris: Seine River Hop-On Hop-Off Sightseeing Cruise',
    url: 'https://www.getyourguide.com/paris-l16/batobus-riverboat-shuttle-service-in-paris-t38938/',
    price: {
      original: '€ 18.99',
      min: '€ 17',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-412764-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-412764-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-412764-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-412764-53.jpg',
    smallDescription: 'Discover Paris at your own pace from the River Seine with a 24 hours or 48 hours pass to the Batobus riverboat shuttle service. Board and alight…',
    description: 'Discover Paris at your own pace from the River Seine with a 24 hours or 48 hours pass to the Batobus riverboat shuttle service. Board and alight where you want as often as you want, and see sights such as the Eiffel Tower, Musée d&#039;Orsay and Notre-Dame.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: true,
    dealMaxPercentage: 10.5,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-412764-68.jpg',
    imageAlt: 'paris seine river hopon hopoff sightseeing cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 1515,
    totalRatingTitle: '1515 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 - 2 days',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 58,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/batobus-riverboat-shuttle-service-in-paris-t38938/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 17 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 58,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 101082,
    title: 'Paris by Vintage Motorbike Sidecar',
    url: 'https://www.getyourguide.com/paris-l16/paris-sidecar-experience-t101082/',
    price: {
      original: '€ 44.50',
      min: '€ 44.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1662912-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1662912-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1662912-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1662912-53.jpg',
    smallDescription: 'Experience Paris from a different perspective aboard an authentic sidecar of a vintage motorbike. Discover the city secrets as a gentleman driver…',
    description: 'Experience Paris from a different perspective aboard an authentic sidecar of a vintage motorbike. Discover the city secrets as a gentleman driver takes you through little-known streets. Hear unusual and astonishing anecdotes on an unforgettable voyage.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
      35,
      55,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1662912-68.jpg',
    imageAlt: 'paris by vintage motorbike sidecar',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.9',
    maxPossibleRating: 5,
    totalRating: 56,
    totalRatingTitle: '56 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '40 - 90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 59,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/paris-l16/paris-sidecar-experience-t101082/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/03/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 45 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/0567fa586f84/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 59,
    highlightedOrientation: 'horizontal',
  },
];

export const toursBarcelona = [
  {
    tourId: 53791,
    title: 'Barcelona: Park Güell Admission Ticket',
    url: 'https://www.getyourguide.com/barcelona-l45/skip-the-line-park-gueell-entrance-ticket-t53791/',
    price: {
      original: '€ 13',
      min: '€ 13',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-344138-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-344138-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-344138-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-344138-53.jpg',
    smallDescription: 'Benefit of the included shuttle bus and visit Park Güell, one of Gaudí’s major works in Barcelona. Take in spectacular views of Barcelona and explore…',
    description: 'Benefit of the included shuttle bus and visit Park Güell, one of Gaudí’s major works in Barcelona. Take in spectacular views of Barcelona and explore this stunning green space that’s surrounded by modernist architecture.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-344138-68.jpg',
    imageAlt: 'barcelona park güell admission ticket',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 12609,
    totalRatingTitle: '12609 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 0,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/skip-the-line-park-gueell-entrance-ticket-t53791/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 13 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 0,
    highlightedOrientation: 'horizontal',
    keyDetails: {
      duration: {
        label: 'Duration:',
        description: '1 day',
      },
    },
  },
  {
    tourId: 232662,
    title: 'Barcelona: Casa Batlló Entrance Ticket with Smart Guide',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-casa-batll-entrance-ticket-with-smart-guide-t232662/',
    price: {
      original: '€ 25',
      min: '€ 25',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1944052-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1944052-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1944052-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1944052-53.jpg',
    smallDescription: 'Discover Casa Batlló, one of Gaudí’s masterpieces, in an immersive experience. Explore this UNESCO World Heritage site with a virtual reality smart…',
    description: 'Discover Casa Batlló, one of Gaudí’s masterpieces, in an immersive experience. Explore this UNESCO World Heritage site with a virtual reality smart guide while learning about an architecture and design legend.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      22,
      29,
      35,
      55,
      39,
      23,
      56,
      93,
      88,
      64,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1944052-68.jpg',
    imageAlt: 'barcelona casa batlló entrance ticket with smart guide',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 1084,
    totalRatingTitle: '1084 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 1,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-casa-batll-entrance-ticket-with-smart-guide-t232662/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 25 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 1,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 50000,
    title: 'Hola BCN: 48, 72, 96, or 120-Hour Public Transport Ticket',
    url: 'https://www.getyourguide.com/barcelona-l45/hola-bcn-barcelona-travel-card-t50000/',
    price: {
      original: '€ 16.30',
      min: '€ 16.30',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-457875-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-457875-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-457875-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-457875-53.jpg',
    smallDescription: 'Explore Barcelona with a public transport ticket that gives you free, unlimited access to the transportation networks in the city and its suburbs.…',
    description: 'Explore Barcelona with a public transport ticket that gives you free, unlimited access to the transportation networks in the city and its suburbs. Experience the beauty of Barcelona and uncover its many treasures with a 48, 72, 96, or 120-hour pass.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-457875-68.jpg',
    imageAlt: 'hola bcn 48 72 96 or 120hour public transport ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 8456,
    totalRatingTitle: '8456 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '48 hours - 96 days',
    validFrom: 'time_booked',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 2,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/hola-bcn-barcelona-travel-card-t50000/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 16 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 2,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 22219,
    title: 'Barcelona Card: 25+ Museums and Free Public Transportation',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-card-2-3-4-or-5-days-with-discounts-t22219/',
    price: {
      original: '€ 205',
      min: '€ 46.13',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-315673-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-315673-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-315673-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-315673-53.jpg',
    smallDescription: 'Access over 25 of Barcelona’s best museums and attractions. Save money, be flexible and enjoy free public transportation with a 3, 4, or 5-day card.',
    description: 'Access over 25 of Barcelona’s best museums and attractions. Save money, be flexible and enjoy free public transportation with a 3, 4, or 5-day card.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      35,
      39,
      55,
    ],
    hasDeal: true,
    dealMaxPercentage: 77.5,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-315673-68.jpg',
    imageAlt: 'barcelona card 25+ museums and free public transportation',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 703,
    totalRatingTitle: '703 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '3 - 5 days',
    validFrom: 'time_activated',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 3,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-card-2-3-4-or-5-days-with-discounts-t22219/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Sunday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 46 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 3,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 73783,
    title: 'Barcelona: Aerobús Shuttle Between Airport and City Center',
    url: 'https://www.getyourguide.com/barcelona-el-prat-airport-l36952/aerobs-shuttle-barcelona-city-center-bcn-airport-t73783/',
    price: {
      original: '€ 10.20',
      min: '€ 10.20',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-490209-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-490209-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-490209-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-490209-53.jpg',
    smallDescription: 'Aerobús is the official shuttle service connecting both terminals 1 and 2 at Barcelona El Prat Airport with the city center. The speedy trip takes…',
    description: 'Aerobús is the official shuttle service connecting both terminals 1 and 2 at Barcelona El Prat Airport with the city center. The speedy trip takes just 35 minutes, with stops at the most strategic points in Barcelona. Enjoy free WiFi during your transfer.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-490209-68.jpg',
    imageAlt: 'barcelona aerobús shuttle between airport and city center',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 713,
    totalRatingTitle: '713 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '35 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 4,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-el-prat-airport-l36952/aerobs-shuttle-barcelona-city-center-bcn-airport-t73783/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available today and tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 10 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 4,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 49864,
    title: 'Casa Milà-La Pedrera: Skip The Line Ticket &amp; Audio Guide',
    url: 'https://www.getyourguide.com/barcelona-l45/skip-the-line-casa-mil-ticket-with-audio-guide-t49864/',
    price: {
      original: '€ 24',
      min: '€ 24',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1849782-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1849782-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1849782-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1849782-53.jpg',
    smallDescription: 'Explore one of the icons of Barcelona with a skip-the-line ticket to the Casa Milà (La Pedrera), Antoni Gaudi’s groundbreaking apartments on the…',
    description: 'Explore one of the icons of Barcelona with a skip-the-line ticket to the Casa Milà (La Pedrera), Antoni Gaudi’s groundbreaking apartments on the Passeig de Gracia. See the Espai Gaudi exhibition, dedicated to Gaudi’s life and architectural innovations.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      12,
      22,
      29,
      35,
      37,
      39,
      55,
      88,
      93,
      23,
      56,
      64,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1849782-68.jpg',
    imageAlt: 'casa milàla pedrera skip the line ticket audio guide',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 4308,
    totalRatingTitle: '4308 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 5,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/skip-the-line-casa-mil-ticket-with-audio-guide-t49864/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/25/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 24 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 5,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 23477,
    title: 'Barcelona’s Montjuïc Cable Car Ride: Round Trip Ticket',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-s-montjuc-cable-car-ride-return-ticket-t23477/',
    price: {
      original: '€ 13.50',
      min: '€ 13.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-307107-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-307107-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-307107-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-307107-53.jpg',
    smallDescription: 'Travel on the recently refurbished Montjuïc Cable Car and get unique views of Barcelona’s coastline from the air. Take the cable car to the top of…',
    description: 'Travel on the recently refurbished Montjuïc Cable Car and get unique views of Barcelona’s coastline from the air. Take the cable car to the top of Montjuïc, from where you will see unbeatable views of the port and city.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-307107-68.jpg',
    imageAlt: 'barcelona’s montjuïc cable car ride round trip ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 3010,
    totalRatingTitle: '3010 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 6,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-s-montjuc-cable-car-ride-return-ticket-t23477/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 14 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 6,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 63888,
    title: 'Barcelona: Sant Pau Recinte Modernista Entry Ticket',
    url: 'https://www.getyourguide.com/barcelona-l45/sant-pau-recinte-modernista-tickets-t63888/',
    price: {
      original: '€ 15',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-415693-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-415693-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-415693-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-415693-53.jpg',
    smallDescription: 'Explore the world’s largest Art Nouveau complex on a 1.5-hour tour of the Sant Pau Recinte Modernista in Barcelona. Travel back in time to the early…',
    description: 'Explore the world’s largest Art Nouveau complex on a 1.5-hour tour of the Sant Pau Recinte Modernista in Barcelona. Travel back in time to the early years of the 20th century and discover the garden city and hospital designed by Lluís Domènech i Montaner.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
      22,
      35,
      39,
      55,
      23,
      93,
      56,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-415693-68.jpg',
    imageAlt: 'barcelona sant pau recinte modernista entry ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 242,
    totalRatingTitle: '242 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 7,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/sant-pau-recinte-modernista-tickets-t63888/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 7,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 110989,
    title: 'Barcelona Skyline and Beaches Boat Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-skyline-and-beaches-boat-tour-t110989/',
    price: {
      original: '€ 7.70',
      min: '€ 7.70',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-748903-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-748903-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-748903-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-748903-53.jpg',
    smallDescription: "Discover Barcelona's highlights from the sea onboard some of the best boats in the city. Take a unique opportunity to enjoy the coastline, sun,…",
    description: 'Discover Barcelona&#039;s highlights from the sea onboard some of the best boats in the city. Take a unique opportunity to enjoy the coastline, sun, breeze, and magic of the sea.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      93,
      56,
      35,
      28,
      22,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-748903-68.jpg',
    imageAlt: 'barcelona skyline and beaches boat tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.8',
    maxPossibleRating: 5,
    totalRating: 52,
    totalRatingTitle: '52 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '40 minutes - 1.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 8,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-skyline-and-beaches-boat-tour-t110989/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 8 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 8,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 385544,
    title: 'Gaudi’s Barcelona: Live Interactive Webinar',
    url: 'https://www.getyourguide.com/barcelona-l45/gaudi-s-barcelona-live-interactive-webinar-t385544/',
    price: {
      original: '€ 15',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3432889-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3432889-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3432889-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3432889-53.jpg',
    smallDescription: "Join a live webinar packed with photos, videos, polls, a live Q&A and a fully interactive chat function to learn about Gaudi's famous works in…",
    description: 'Join a live webinar packed with photos, videos, polls, a live Q&amp;A and a fully interactive chat function to learn about Gaudi&#039;s famous works in Barcelona.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3432889-68.jpg',
    imageAlt: 'gaudi’s barcelona live interactive webinar',
    isFreeCancellation: true,
    hasRating: false,
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 9,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/gaudi-s-barcelona-live-interactive-webinar-t385544/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Sunday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 9,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 206328,
    title: 'Park Güell: Skip-the-Line Guided Tour',
    url: 'https://www.getyourguide.com/park-gueell-l3032/park-gueell-skip-the-line-tour-and-transfer-t206328/',
    price: {
      original: '€ 26',
      min: '€ 26',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1542126-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1542126-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1542126-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1542126-53.jpg',
    smallDescription: "Immerse yourself in Guadí's wonderous open-air work of art on this guided tour of Park Güell. Enjoy skip-the-line entry and English-speaking…",
    description: 'Immerse yourself in Guadí&#039;s wonderous open-air work of art on this guided tour of Park Güell. Enjoy skip-the-line entry and English-speaking commentary from your guide so that you can make the most of your vacation time.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1542126-68.jpg',
    imageAlt: 'park güell skiptheline guided tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.6',
    maxPossibleRating: 5,
    totalRating: 34,
    totalRatingTitle: '34 Reviews',
    averageRatingClass: '35',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 10,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/park-gueell-l3032/park-gueell-skip-the-line-tour-and-transfer-t206328/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 03/28/2021',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 26 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 10,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 125012,
    title: 'Barcelona: Theater Flamenco Zone B Tickets',
    url: 'https://www.getyourguide.com/flamenco-barcelona-sl-l111387/middle-row-seats-t125012/',
    price: {
      original: '€ 25',
      min: '€ 25',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-858485-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-858485-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-858485-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-858485-53.jpg',
    smallDescription: 'Sit in the middle row of the theater, just a few meters from the stage with a fantastic view of the show. The staff will make you feel comfortable,…',
    description: 'Sit in the middle row of the theater, just a few meters from the stage with a fantastic view of the show. The staff will make you feel comfortable, ensuring you have everything you need for a great night.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-858485-68.jpg',
    imageAlt: 'barcelona theater flamenco zone b tickets',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.1',
    maxPossibleRating: 5,
    totalRating: 45,
    totalRatingTitle: '45 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.1 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 11,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/flamenco-barcelona-sl-l111387/middle-row-seats-t125012/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 25 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 11,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 61515,
    title: 'Barcelona Aquarium: Skip-the-Line Admission Ticket',
    url: 'https://www.getyourguide.com/barcelona-l45/ticket-barcelona-aquarium-t61515/',
    price: {
      original: '€ 21',
      min: '€ 21',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-690509-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-690509-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-690509-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-690509-53.jpg',
    smallDescription: 'Visit the unique Barcelona Aquarium, entering without delay on a skip-the-line ticket. Experience the spectacular Oceanarium as you walk along a…',
    description: 'Visit the unique Barcelona Aquarium, entering without delay on a skip-the-line ticket. Experience the spectacular Oceanarium as you walk along a transparent tunnel surrounded by sharks. Learn about the seabed and the importance of water to the planet.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-690509-68.jpg',
    imageAlt: 'barcelona aquarium skiptheline admission ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 1993,
    totalRatingTitle: '1993 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 12,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/ticket-barcelona-aquarium-t61515/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 21 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 12,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 314117,
    title: 'Barcelona: 2-Hour Sailing Experience with Refreshments',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-2-hr-sunset-sailing-experience-with-refreshments-t314117/',
    price: {
      original: '€ 49',
      min: '€ 39.20',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2746668-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2746668-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2746668-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2746668-53.jpg',
    smallDescription: 'Explore Barcelona from the sea on a comfortable new Sailing Yacht with a professional skipper. Admire the city skyline from the water, and try some…',
    description: 'Explore Barcelona from the sea on a comfortable new Sailing Yacht with a professional skipper. Admire the city skyline from the water, and try some delicious appetizers accompanied by wines and champagnes from the best producing regions of Catalonia.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
      35,
      55,
      39,
    ],
    hasDeal: true,
    dealMaxPercentage: 20,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2746668-68.jpg',
    imageAlt: 'barcelona 2hour sailing experience with refreshments',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.9',
    maxPossibleRating: 5,
    totalRating: 35,
    totalRatingTitle: '35 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 13,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-2-hr-sunset-sailing-experience-with-refreshments-t314117/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 39 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 13,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 168693,
    title: 'Barcelona: 360º Boat Trip',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-50-minute-360-boat-trip-t168693/',
    price: {
      original: '€ 12',
      min: '€ 12',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1670814-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1670814-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1670814-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1670814-53.jpg',
    smallDescription: 'Enjoy a fun and adrenaline-building experience on board a speed boat whilst admiring the Barcelona skyline from the ocean.',
    description: 'Enjoy a fun and adrenaline-building experience on board a speed boat whilst admiring the Barcelona skyline from the ocean.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      22,
      29,
      55,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1670814-68.jpg',
    imageAlt: 'barcelona 360º boat trip',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 398,
    totalRatingTitle: '398 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '30 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 14,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-50-minute-360-boat-trip-t168693/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/19/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 12 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 14,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 44533,
    title: 'Barcelona: Paella Cooking Experience + Boqueria Market Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/paella-cooking-experience-with-boqueria-market-tour-t44533/',
    price: {
      original: '€ 39',
      min: '€ 39',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2198332-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2198332-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2198332-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2198332-53.jpg',
    smallDescription: 'Learn how to cook a traditional Spanish seafood paella. Visit La Boqueria with the chef to buy ingredients, and take a walk through the old town.…',
    description: 'Learn how to cook a traditional Spanish seafood paella. Visit La Boqueria with the chef to buy ingredients, and take a walk through the old town. Sample some tasty tapas, make sangria, and watch as the chef prepares a paella de marisco for you to enjoy.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2198332-68.jpg',
    imageAlt: 'barcelona paella cooking experience + boqueria market tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 418,
    totalRatingTitle: '418 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 15,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/paella-cooking-experience-with-boqueria-market-tour-t44533/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 39 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 15,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 1225,
    title: 'Hop-On Hop-Off Barcelona City Tour 1 or 2 Day',
    url: 'https://www.getyourguide.com/barcelona-l45/hop-on-hop-off-barcelona-city-tour-1-or-2-day-t1225/',
    price: {
      original: '€ 30',
      min: '€ 30',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-263339-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-263339-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-263339-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-263339-53.jpg',
    smallDescription: 'Discover Barcelona at your own pace on a double-decker hop-on hop-off bus tour! Choose from 1 or 2 days and access 2 routes with stops at the best…',
    description: 'Discover Barcelona at your own pace on a double-decker hop-on hop-off bus tour! Choose from 1 or 2 days and access 2 routes with stops at the best sites in Barcelona! Plus, enjoy audio commentary in 15 different languages as you travel through the city.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      22,
      23,
      28,
      29,
      35,
      39,
      46,
      55,
      56,
      88,
      93,
      45,
      6,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-263339-68.jpg',
    imageAlt: 'hopon hopoff barcelona city tour 1 or 2 day',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 3979,
    totalRatingTitle: '3979 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 - 2 days',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 16,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/hop-on-hop-off-barcelona-city-tour-1-or-2-day-t1225/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 30 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 16,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 32004,
    title: 'Barcelona: City Sights Highlight Bike Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/bike-tour-through-barcelona-t32004/',
    price: {
      original: '€ 39',
      min: '€ 39',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-322577-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-322577-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-322577-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-322577-53.jpg',
    smallDescription: "Discover Barcelona on a bike tour. Ride over bike lanes, pedestrian paths, and parks and gardens to the city's most beautiful sights. Admire the old…",
    description: 'Discover Barcelona on a bike tour. Ride over bike lanes, pedestrian paths, and parks and gardens to the city&#039;s most beautiful sights. Admire the old architecture, enjoy the views from the beach and discover the hidden corners of the city.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      39,
      35,
      29,
      28,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-322577-68.jpg',
    imageAlt: 'barcelona city sights highlight bike tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 1417,
    totalRatingTitle: '1417 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 17,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/bike-tour-through-barcelona-t32004/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 39 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 17,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 49934,
    title: 'Barcelona 1-Hour Flamenco Show at Palacio del Flamenco',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-palacio-del-flamenco-1-hour-show-t49934/',
    price: {
      original: '€ 35',
      min: '€ 35',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520777-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520777-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520777-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520777-53.jpg',
    smallDescription: 'Immerse yourself in the sensuous rhythms of Spanish flamenco at a 1-hour show at Barcelona’s Palacio del Flamenco. Choose from 3 unique performances,…',
    description: 'Immerse yourself in the sensuous rhythms of Spanish flamenco at a 1-hour show at Barcelona’s Palacio del Flamenco. Choose from 3 unique performances, each presented by an enthusiastic cast of flamenco dancers, singers and musicians.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-520777-68.jpg',
    imageAlt: 'barcelona 1hour flamenco show at palacio del flamenco',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 696,
    totalRatingTitle: '696 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 18,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-palacio-del-flamenco-1-hour-show-t49934/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 35 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 18,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 29293,
    title: 'Fast-Track Access: Sagrada Familia 1.5-Hour Guided Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/sagrada-familia-skip-the-line-t29293/',
    price: {
      original: '€ 47',
      min: '€ 47',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-307750-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-307750-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-307750-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-307750-53.jpg',
    smallDescription: "Visit Barcelona's majestic Sagrada Familia, designed by the great Modernist visionary Antoni Gaudí. Get fast track entry with a pre-booked ticket to…",
    description: 'Visit Barcelona&#039;s majestic Sagrada Familia, designed by the great Modernist visionary Antoni Gaudí. Get fast track entry with a pre-booked ticket to the stunning Art Nouveau masterpiece and enjoy a 1.5-hour tour of the Basilica and Sagrada Familia Museum.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      35,
      109,
      55,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-307750-68.jpg',
    imageAlt: 'fasttrack access sagrada familia 1.5hour guided tour',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 1565,
    totalRatingTitle: '1565 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 19,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/sagrada-familia-skip-the-line-t29293/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 47 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 19,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 54571,
    title: 'Barcelona: Tibidabo Amusement Park Admission Ticket',
    url: 'https://www.getyourguide.com/barcelona-l45/tibidabo-amusement-park-entrance-ticket-t54571/',
    price: {
      original: '€ 12.70',
      min: '€ 12.70',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520234-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520234-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520234-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520234-53.jpg',
    smallDescription: 'Spend a day at Tibidabo Amusement Park, a magical place that’s been around for more than a century, and is a symbol of Barcelona. Your ticket…',
    description: 'Spend a day at Tibidabo Amusement Park, a magical place that’s been around for more than a century, and is a symbol of Barcelona. Your ticket provides access to all of the park’s attractions. Enjoy the views of Barcelona and the surrounding area as well.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-520234-68.jpg',
    imageAlt: 'barcelona tibidabo amusement park admission ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.0',
    maxPossibleRating: 5,
    totalRating: 175,
    totalRatingTitle: '175 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 day',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 20,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/tibidabo-amusement-park-entrance-ticket-t54571/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 13 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 20,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 149552,
    title: 'Barcelona: Sunset Catamaran Cruise with Live Music',
    url: 'https://www.getyourguide.com/barcelona-l45/90-minute-sunset-catamaran-cruise-with-live-music-t149552/',
    price: {
      original: '€ 21.50',
      min: '€ 21.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3427218-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3427218-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3427218-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3427218-53.jpg',
    smallDescription: "See the sunset over Barcelona from the comfort of a 78-foot catamaran. Enjoy live music and stunning views of the city's skyline, with drinks…",
    description: 'See the sunset over Barcelona from the comfort of a 78-foot catamaran. Enjoy live music and stunning views of the city&#039;s skyline, with drinks available for purchase onboard.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3427218-68.jpg',
    imageAlt: 'barcelona sunset catamaran cruise with live music',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 302,
    totalRatingTitle: '302 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 21,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/90-minute-sunset-catamaran-cruise-with-live-music-t149552/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 22 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 21,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 4241,
    title: 'Barcelona Hop-on Hop-off Tour: 1 or 2- Day Ticket',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-hop-on-hop-off-tour-1-or-2-day-ticket-t4241/',
    price: {
      original: '€ 30',
      min: '€ 30',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1089291-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1089291-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1089291-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1089291-53.jpg',
    smallDescription: 'See the fascinating city of Barcelona on a comfortable and convenient hop-on hop-off bus tour. You’ll travel on open-top double-decker buses that…',
    description: 'See the fascinating city of Barcelona on a comfortable and convenient hop-on hop-off bus tour. You’ll travel on open-top double-decker buses that cover 3 different routes. Your 1-day or 2-day ticket makes it possible see all that Barcelona has to offer!',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      22,
      23,
      29,
      35,
      39,
      55,
      56,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1089291-68.jpg',
    imageAlt: 'barcelona hopon hopoff tour 1 or 2 day ticket',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 1396,
    totalRatingTitle: '1396 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '3 months',
    validFrom: 'time_booked',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 22,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-hop-on-hop-off-tour-1-or-2-day-ticket-t4241/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 30 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 22,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 76003,
    title: 'Barcelona: Flamenco Show at City Hall Theater',
    url: 'https://www.getyourguide.com/barcelona-l45/flamenco-barcelona-in-city-hall-theater-t76003/',
    price: {
      original: '€ 18',
      min: '€ 18',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1877577-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1877577-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1877577-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1877577-53.jpg',
    smallDescription: "Experience the passion of flamenco music and dance with a ticket to a 1-hour performance at Barcelona's historic City Hall Theater. Marvel at the…",
    description: 'Experience the passion of flamenco music and dance with a ticket to a 1-hour performance at Barcelona&#039;s historic City Hall Theater. Marvel at the artistry of the talented performers and get into the spirit of an authentic form of Spanish dance.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1877577-68.jpg',
    imageAlt: 'barcelona flamenco show at city hall theater',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 488,
    totalRatingTitle: '488 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 23,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/flamenco-barcelona-in-city-hall-theater-t76003/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 18 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 23,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 39051,
    title: 'Montserrat, Tapas and Wine Half-Day Tour from Barcelona',
    url: 'https://www.getyourguide.com/barcelona-l45/montserrat-tapas-wine-half-day-t39051/',
    price: {
      original: '€ 74.95',
      min: '€ 74.95',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661014-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661014-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661014-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-661014-53.jpg',
    smallDescription: 'Taste delicious Spanish wines and tapas at a boutique winery on a 7-hour tour from Barcelona that also includes a short visit to the stunning…',
    description: 'Taste delicious Spanish wines and tapas at a boutique winery on a 7-hour tour from Barcelona that also includes a short visit to the stunning Montserrat mountain complex, surrounded by gorgeous fields and jaw dropping views.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-661014-68.jpg',
    imageAlt: 'montserrat tapas and wine halfday tour from barcelona',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 429,
    totalRatingTitle: '429 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '6 - 7 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 24,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/montserrat-tapas-wine-half-day-t39051/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: '7 spots available tomorrow',
    cardBannerType: 'urgent',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 75 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 24,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 140241,
    title: 'Sagrada Familia: Skip-the-Line Guided Tour with Tower',
    url: 'https://www.getyourguide.com/barcelona-l45/sagrada-familia-fast-track-guided-tour-w-towers-access-t140241/',
    price: {
      original: '€ 64',
      min: '€ 64',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2395375-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2395375-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2395375-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2395375-53.jpg',
    smallDescription: "Skip the long lines to the Sagrada Familia on a 2-hour guided tour of the iconic monument. Explore Gaudi's impressive masterpiece and get panoramic…",
    description: 'Skip the long lines to the Sagrada Familia on a 2-hour guided tour of the iconic monument. Explore Gaudi&#039;s impressive masterpiece and get panoramic views of Barcelona from the top of the tower.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2395375-68.jpg',
    imageAlt: 'sagrada familia skiptheline guided tour with tower',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 385,
    totalRatingTitle: '385 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 25,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/sagrada-familia-fast-track-guided-tour-w-towers-access-t140241/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/16/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 64 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 25,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 122421,
    title: 'Montserrat Monastery &amp; Museum Ticket &amp; Audio Guide',
    url: 'https://www.getyourguide.com/barcelona-l45/montserrat-monastery-and-museum-admission-ticket-t122421/',
    price: {
      original: '€ 16',
      min: '€ 16',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-840740-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-840740-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-840740-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-840740-53.jpg',
    smallDescription: 'Visit the fascinating Montserrat complex with this ticket. Visit the Basilica of the Monastery, discover the Open Air Museum, the Museum of…',
    description: 'Visit the fascinating Montserrat complex with this ticket. Visit the Basilica of the Monastery, discover the Open Air Museum, the Museum of Montserrat and the new Montserrat Audiovisual Room.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      35,
      39,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-840740-68.jpg',
    imageAlt: 'montserrat monastery museum ticket audio guide',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 209,
    totalRatingTitle: '209 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 26,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/montserrat-monastery-and-museum-admission-ticket-t122421/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/16/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 16 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 26,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 2323,
    title: 'Barcelona: Skip-the-Line Park Güell Guided Walking Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/park-guell-guided-walking-tour-t2323/',
    price: {
      original: '€ 27',
      min: '€ 27',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-308791-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-308791-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-308791-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-308791-53.jpg',
    smallDescription: 'Visit the most artistically significant park in the city of Barcelona. Join a guided tour through the site and learn about its history and secrets…',
    description: 'Visit the most artistically significant park in the city of Barcelona. Join a guided tour through the site and learn about its history and secrets with a local guide.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
      55,
      35,
      39,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-308791-68.jpg',
    imageAlt: 'barcelona skiptheline park güell guided walking tour',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.2',
    maxPossibleRating: 5,
    totalRating: 490,
    totalRatingTitle: '490 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.2 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1.3 - 1.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 27,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/park-guell-guided-walking-tour-t2323/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 27 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 27,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 147462,
    title: 'Barcelona: The Classic Segway Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-the-classic-segway-tour-t147462/',
    price: {
      original: '€ 49',
      min: '€ 49',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2869326-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2869326-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2869326-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2869326-53.jpg',
    smallDescription: 'Discover the charm of Barcelona on a Segway tour. During more than 12 km, you will visit the beaches and ports of Barcelona before transporting…',
    description: 'Discover the charm of Barcelona on a Segway tour. During more than 12 km, you will visit the beaches and ports of Barcelona before transporting yourself to a more avant-garde and modern city in a fun way.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      109,
      22,
      29,
      35,
      55,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2869326-68.jpg',
    imageAlt: 'barcelona the classic segway tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 10,
    totalRatingTitle: '10 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 28,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-the-classic-segway-tour-t147462/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 49 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 28,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 65715,
    title: 'Barcelona: Generation Pub Crawl',
    url: 'https://www.getyourguide.com/barcelona-l45/the-backpacker-pub-crawl-barcelona-t65715/',
    price: {
      original: '€ 15',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2352540-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2352540-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2352540-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2352540-53.jpg',
    smallDescription: 'Join a local guide who will take you to authentic tapas bars, pubs and clubs on a night out to remember. Experience the thrilling nightlife in…',
    description: 'Join a local guide who will take you to authentic tapas bars, pubs and clubs on a night out to remember. Experience the thrilling nightlife in Barcelona, enjoy free drinks and discounts and skip-the-line VIP admission to a top club.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2352540-68.jpg',
    imageAlt: 'barcelona generation pub crawl',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.0',
    maxPossibleRating: 5,
    totalRating: 142,
    totalRatingTitle: '142 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 29,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/the-backpacker-pub-crawl-barcelona-t65715/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: '20 spots available tomorrow',
    cardBannerType: 'urgent',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 29,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 244267,
    title: 'Barcelona: Jazz at the Jamboree Concert Hall',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-jazz-at-the-jamboree-concert-hall-t244267/',
    price: {
      original: '€ 15',
      min: '€ 15',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2093507-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2093507-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2093507-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2093507-53.jpg',
    smallDescription: 'Jamboree Concert Hall in Barcelona is where world jazz legends have taken to the stage. Under the arches of the Plaça Reial, find the Jamboree, one…',
    description: 'Jamboree Concert Hall in Barcelona is where world jazz legends have taken to the stage. Under the arches of the Plaça Reial, find the Jamboree, one of the country’s few venues where you can enjoy the best in live jazz music.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2093507-68.jpg',
    imageAlt: 'barcelona jazz at the jamboree concert hall',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 13,
    totalRatingTitle: '13 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 30,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-jazz-at-the-jamboree-concert-hall-t244267/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available today and tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 30,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 58015,
    title: 'From Barcelona: Girona Game of Thrones Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/girona-half-day-trip-from-barcelona-t58015/',
    price: {
      original: '€ 55',
      min: '€ 55',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2321827-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2321827-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2321827-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2321827-53.jpg',
    smallDescription: 'Travel from Barcelona to discover the wonders of one of the most fascinating cities in Catalonia and learn about its cultural heritage. Walk through…',
    description: 'Travel from Barcelona to discover the wonders of one of the most fascinating cities in Catalonia and learn about its cultural heritage. Walk through Girona’s winding medieval streets and its Jewish quarter, one of the best-preserved in the world.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2321827-68.jpg',
    imageAlt: 'from barcelona girona game of thrones tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 64,
    totalRatingTitle: '64 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '6 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 31,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/girona-half-day-trip-from-barcelona-t58015/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 55 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 31,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 8311,
    title: 'Skip the Line: Hard Rock Cafe Barcelona',
    url: 'https://www.getyourguide.com/barcelona-l45/skip-the-line-hard-rock-cafe-barcelona-t8311/',
    price: {
      original: '€ 20.31',
      min: '€ 20.31',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3415109-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3415109-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3415109-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3415109-53.jpg',
    smallDescription: 'Skip the line at Hard Rock Cafe Barcelona and enjoy priority entrance. Choose from 2 menus featuring high-quality American food in a setting that…',
    description: 'Skip the line at Hard Rock Cafe Barcelona and enjoy priority entrance. Choose from 2 menus featuring high-quality American food in a setting that celebrates music and features an array of rock &#039;n&#039; roll memorabilia. Non-alcoholic beverage included.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3415109-68.jpg',
    imageAlt: 'skip the line hard rock cafe barcelona',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 433,
    totalRatingTitle: '433 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '75 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 32,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/skip-the-line-hard-rock-cafe-barcelona-t8311/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: '18 spots available tomorrow',
    cardBannerType: 'urgent',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 20 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 32,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 53220,
    title: 'Barcelona: La Pedrera Night Experience',
    url: 'https://www.getyourguide.com/barcelona-l45/la-pedrera-night-time-show-skip-the-line-ticket-t53220/',
    price: {
      original: '€ 34',
      min: '€ 34',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-416642-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-416642-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-416642-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-416642-53.jpg',
    smallDescription: 'Skip the lines to one of Barcelona’s most iconic buildings and watch an amazing audiovisual display on the roof terrace. Get a short introduction to…',
    description: 'Skip the lines to one of Barcelona’s most iconic buildings and watch an amazing audiovisual display on the roof terrace. Get a short introduction to Gaudi’s revolutionary building on the Passeig de Gracia, and see multiple projections in the stairwells.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
      23,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-416642-68.jpg',
    imageAlt: 'barcelona la pedrera night experience',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 561,
    totalRatingTitle: '561 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 33,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/la-pedrera-night-time-show-skip-the-line-ticket-t53220/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 34 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 33,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 321563,
    title: 'Barcelona: Gothic Quarter Ghost Tour Game',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-haunted-city-game-and-walking-tour-t321563/',
    price: {
      original: '€ 14.99',
      min: '€ 14.99',
      type: 'group',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3107000-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3107000-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3107000-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3107000-53.jpg',
    smallDescription: 'Go on a quest around the haunted parts of Barcelona by following clues that will unlock stories about the Barcelona Cathedral, Pont del Bisbe, Mercat…',
    description: 'Go on a quest around the haunted parts of Barcelona by following clues that will unlock stories about the Barcelona Cathedral, Pont del Bisbe, Mercat de Santa Caterina, and more. You will solve puzzles, starting and pausing the game whenever you like.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3107000-68.jpg',
    imageAlt: 'barcelona gothic quarter ghost tour game',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 8,
    totalRatingTitle: '8 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 34,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-haunted-city-game-and-walking-tour-t321563/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available today and tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 15 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 34,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 66363,
    title: 'Barcelona: Tapas and Flamenco Experience',
    url: 'https://www.getyourguide.com/barcelona-l45/tapas-and-flamenco-experience-t66363/',
    price: {
      original: '€ 39',
      min: '€ 39',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-440560-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-440560-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-440560-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-440560-53.jpg',
    smallDescription: "Experience the passion of the flamenco at a fiery flamenco show in the heart of Barcelona's Gothic Quarter. Then, feast on traditional Spanish food…",
    description: 'Experience the passion of the flamenco at a fiery flamenco show in the heart of Barcelona&#039;s Gothic Quarter. Then, feast on traditional Spanish food at a sit-down tapas dinner. Sample multiple fresh tapas dishes with complimentary sangria.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-440560-68.jpg',
    imageAlt: 'barcelona tapas and flamenco experience',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.1',
    maxPossibleRating: 5,
    totalRating: 341,
    totalRatingTitle: '341 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.1 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 35,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/tapas-and-flamenco-experience-t66363/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available today and tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 39 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 35,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 504,
    title: 'Barcelona: Hot Air Balloon Flight with Pickup',
    url: 'https://www.getyourguide.com/barcelona-l45/hot-air-balloon-ride-from-barcelona-t504/',
    price: {
      original: '€ 190',
      min: '€ 190',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-343872-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-343872-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-343872-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-343872-53.jpg',
    smallDescription: "Get panoramic views of Catalonia's natural landscape while floating above it in a hot air ballon. See the Montserrat peaks, Barcelona city, and the…",
    description: 'Get panoramic views of Catalonia&#039;s natural landscape while floating above it in a hot air ballon. See the Montserrat peaks, Barcelona city, and the Mediterranean Sea. The adventure begins at dawn!',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      35,
      109,
      22,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-343872-68.jpg',
    imageAlt: 'barcelona hot air balloon flight with pickup',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 96,
    totalRatingTitle: '96 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 36,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/hot-air-balloon-ride-from-barcelona-t504/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Thursday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 190 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 36,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 71385,
    title: 'Barcelona: Small Group Segway Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-15-hour-segway-tour-t71385/',
    price: {
      original: '€ 39',
      min: '€ 39',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-471338-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-471338-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-471338-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-471338-53.jpg',
    smallDescription: "Get an introduction to the history of Barcelona on a 1.5-hour Segway tour. Glide through Parc de la Ciutadella, get a sense of the city's maritime…",
    description: 'Get an introduction to the history of Barcelona on a 1.5-hour Segway tour. Glide through Parc de la Ciutadella, get a sense of the city&#039;s maritime history at Port Vell and visit the Olympic Village from the 1992 Olympic Games.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      35,
      39,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-471338-68.jpg',
    imageAlt: 'barcelona small group segway tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.9',
    maxPossibleRating: 5,
    totalRating: 29,
    totalRatingTitle: '29 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 37,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-15-hour-segway-tour-t71385/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 39 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 37,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 157464,
    title: 'The Ice Bar Experience at Icebarcelona',
    url: 'https://www.getyourguide.com/barcelona-l45/the-ice-bar-experience-at-icebarcelona-t157464/',
    price: {
      original: '€ 16.50',
      min: '€ 16.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1684488-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1684488-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1684488-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1684488-53.jpg',
    smallDescription: 'Experience the first ice bar on the beach in the world! Enter an experimental and avant-garde environment 5 degrees below zero. At least twice a…',
    description: 'Experience the first ice bar on the beach in the world! Enter an experimental and avant-garde environment 5 degrees below zero. At least twice a year, the theme of the room, the lighting, and the sculptures are updated.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1684488-68.jpg',
    imageAlt: 'the ice bar experience at icebarcelona',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.9',
    maxPossibleRating: 5,
    totalRating: 324,
    totalRatingTitle: '324 Reviews',
    averageRatingClass: '40',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '45 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 38,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/the-ice-bar-experience-at-icebarcelona-t157464/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available today and tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 17 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 38,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 173466,
    title: 'Barcelona Hop-On Hop-Off &amp; F.C. Barcelona Camp Nou Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-hop-on-hop-off-fc-barcelona-camp-nou-tour-t173466/',
    price: {
      original: '€ 63',
      min: '€ 63',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1255767-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1255767-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1255767-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1255767-53.jpg',
    smallDescription: 'Enjoy this combo-tour including a ticket for one or two days for the Hop-On Hop-Off Barcelona City Tour, and one ticket for Camp Nou Experience F.C.…',
    description: 'Enjoy this combo-tour including a ticket for one or two days for the Hop-On Hop-Off Barcelona City Tour, and one ticket for Camp Nou Experience F.C. Barcelona Museum &amp; Tour.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      22,
      23,
      28,
      29,
      35,
      39,
      45,
      46,
      55,
      56,
      6,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1255767-68.jpg',
    imageAlt: 'barcelona hopon hopoff f.c. barcelona camp nou tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 138,
    totalRatingTitle: '138 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 - 2 days',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 39,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-hop-on-hop-off-fc-barcelona-camp-nou-tour-t173466/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 63 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 39,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 99690,
    title: 'Barcelona Main Sights 2.5-Hour Tour by E-Bike',
    url: 'https://www.getyourguide.com/barcelona-l45/historical-e-bike-tour-through-barcelona-s-main-sights-t99690/',
    price: {
      original: '€ 34',
      min: '€ 34',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-654099-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-654099-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-654099-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-654099-53.jpg',
    smallDescription: 'Discover the main sights of Barcelona with a local guide on a 2.5-hour electric bike tour. Learn the history of the Gothic Quarter and see landmark…',
    description: 'Discover the main sights of Barcelona with a local guide on a 2.5-hour electric bike tour. Learn the history of the Gothic Quarter and see landmark monuments such as the cathedral and city hall.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      35,
      39,
      55,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-654099-68.jpg',
    imageAlt: 'barcelona main sights 2.5hour tour by ebike',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 125,
    totalRatingTitle: '125 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 40,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/historical-e-bike-tour-through-barcelona-s-main-sights-t99690/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 34 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 40,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 243512,
    title: 'Montserrat &amp; Gaudí: Premium Full-Day Tour From Barcelona',
    url: 'https://www.getyourguide.com/barcelona-l45/montserrat-gaud-premium-full-day-tour-from-barcelona-t243512/',
    price: {
      original: '€ 72',
      min: '€ 72',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2170462-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2170462-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2170462-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2170462-53.jpg',
    smallDescription: "This full-day tour takes you to some of Catalonia's most famous landmarks. Enjoy a day in Catalonia’s beautiful mountain range, Monserrat, then visit…",
    description: 'This full-day tour takes you to some of Catalonia&#039;s most famous landmarks. Enjoy a day in Catalonia’s beautiful mountain range, Monserrat, then visit Gaudi’s Crypt in Colonia Güell, a hidden jewel outside Barcelona.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      22,
      109,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2170462-68.jpg',
    imageAlt: 'montserrat gaudí premium fullday tour from barcelona',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.9',
    maxPossibleRating: 5,
    totalRating: 16,
    totalRatingTitle: '16 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '8 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 41,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/montserrat-gaud-premium-full-day-tour-from-barcelona-t243512/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 72 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 41,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 129276,
    title: 'Barcelona Port Vell: Afternoon Merienda Sailing Cruise',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-2-hour-afternoon-merienda-sailing-from-port-vell-t129276/',
    price: {
      original: '€ 53',
      min: '€ 53',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1618866-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1618866-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1618866-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1618866-53.jpg',
    smallDescription: "Board a 12-meter yacht for a 2-hour sail from Barcelona's Port Vell, along the coast to Barceloneta. Enjoy light snacks and drinks on board.",
    description: 'Board a 12-meter yacht for a 2-hour sail from Barcelona&#039;s Port Vell, along the coast to Barceloneta. Enjoy light snacks and drinks on board.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1618866-68.jpg',
    imageAlt: 'barcelona port vell afternoon merienda sailing cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 17,
    totalRatingTitle: '17 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 42,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-2-hour-afternoon-merienda-sailing-from-port-vell-t129276/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 53 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 42,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 89997,
    title: 'Barcelona Best Sunset Cruise',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-sunset-cruise-t89997/',
    price: {
      original: '€ 58',
      min: '€ 58',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1412645-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1412645-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1412645-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1412645-53.jpg',
    smallDescription: 'Experience Barcelona from an unusual point of view and take in the sunset from a catamaran or sailboat. Relax and enjoy the refreshments on board.',
    description: 'Experience Barcelona from an unusual point of view and take in the sunset from a catamaran or sailboat. Relax and enjoy the refreshments on board.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      35,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1412645-68.jpg',
    imageAlt: 'barcelona best sunset cruise',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 72,
    totalRatingTitle: '72 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '90 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 43,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-sunset-cruise-t89997/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 58 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 43,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 77794,
    title: 'Barcelona: Les Punxes Entrance Ticket with Audio Guide',
    url: 'https://www.getyourguide.com/casa-de-les-punxes-l3068/barcelona-les-punxes-entrance-ticket-w-audio-guide-t77794/',
    price: {
      original: '€ 13.50',
      min: '€ 13.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1097970-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1097970-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1097970-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1097970-53.jpg',
    smallDescription: 'Discover the Legend of Sant Jordi, a key part of Catalan history. Immerse yourself in the modernism of Josep Puig i Cadafalch through his most…',
    description: 'Discover the Legend of Sant Jordi, a key part of Catalan history. Immerse yourself in the modernism of Josep Puig i Cadafalch through his most subjective work, Casa de les Punxes.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      22,
      23,
      29,
      35,
      39,
      55,
      56,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1097970-68.jpg',
    imageAlt: 'barcelona les punxes entrance ticket with audio guide',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.3',
    maxPossibleRating: 5,
    totalRating: 33,
    totalRatingTitle: '33 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.3 out of 5',
    hasDuration: true,
    useValidity: true,
    duration: '1 day',
    validFrom: 'time_selected',
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 44,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/casa-de-les-punxes-l3068/barcelona-les-punxes-entrance-ticket-w-audio-guide-t77794/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available today and tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 14 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 44,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 166121,
    title: '6 Minute Helicopter Flight over Barcelona&#039;s Coastline',
    url: 'https://www.getyourguide.com/barcelona-l45/6-minute-helicopter-flight-over-barcelona-s-coastline-t166121/',
    price: {
      original: '€ 79',
      min: '€ 79',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1195775-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1195775-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1195775-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1195775-53.jpg',
    smallDescription: 'Join this flight and be amazed at how different the city looks from the sky. See famous Barcelona landmarks and fly along the coastline of Barcelona.…',
    description: 'Join this flight and be amazed at how different the city looks from the sky. See famous Barcelona landmarks and fly along the coastline of Barcelona. Take this thrilling flight and enjoy a memorable experience.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1195775-68.jpg',
    imageAlt: '6 minute helicopter flight over barcelonas coastline',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 86,
    totalRatingTitle: '86 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '6 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 45,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/6-minute-helicopter-flight-over-barcelona-s-coastline-t166121/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from Thursday',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 79 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 45,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 156042,
    title: 'From Barcelona: Montserrat Monastery and Hike with a Local',
    url: 'https://www.getyourguide.com/barcelona-l45/from-barcelona-montserrat-monastery-and-hike-with-a-local-t156042/',
    price: {
      original: '€ 65',
      min: '€ 65',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3435291-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3435291-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3435291-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3435291-53.jpg',
    smallDescription: 'Hike around the trails of Montserrat, the world famous multi-peaked sawed mountain with a local guide. Visit the Benedictine Abbey and hear the boys…',
    description: 'Hike around the trails of Montserrat, the world famous multi-peaked sawed mountain with a local guide. Visit the Benedictine Abbey and hear the boys choir - Escolania de Montserrat. Enjoy a unique half-day excursion from Barcelona.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      22,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3435291-68.jpg',
    imageAlt: 'from barcelona montserrat monastery and hike with a local',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 27,
    totalRatingTitle: '27 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '6 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 46,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/from-barcelona-montserrat-monastery-and-hike-with-a-local-t156042/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: '8 spots available tomorrow',
    cardBannerType: 'urgent',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 65 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 46,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 137471,
    title: 'Sagrada Família Basilica Skip-the-Line Guided Tour',
    url: 'https://www.getyourguide.com/sagrada-familia-l2699/skip-the-line-la-sagrada-famlia-express-tour-t137471/',
    price: {
      original: '€ 39',
      min: '€ 39',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-964079-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-964079-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-964079-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-964079-53.jpg',
    smallDescription: "Save precious time and skip the long lines to the Sagrada Família to explore Gaudí's unfinished masterpiece on a small group guided tour. Marvel at…",
    description: 'Save precious time and skip the long lines to the Sagrada Família to explore Gaudí&#039;s unfinished masterpiece on a small group guided tour. Marvel at different features of the basilica from the outside and inside.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-964079-68.jpg',
    imageAlt: 'sagrada família basilica skiptheline guided tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 65,
    totalRatingTitle: '65 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1.25 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 47,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/sagrada-familia-l2699/skip-the-line-la-sagrada-famlia-express-tour-t137471/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 39 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 47,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 79827,
    title: 'Welcome to Barcelona: Private Tour with a Local',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-welcome-tour-private-tour-with-a-local-t79827/',
    price: {
      original: '€ 30',
      min: '€ 30',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-533280-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-533280-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-533280-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-533280-53.jpg',
    smallDescription: 'Get a welcome to Barcelona from a friendly and passionate local and discover the city like a resident. Learn the secrets about where to buy…',
    description: 'Get a welcome to Barcelona from a friendly and passionate local and discover the city like a resident. Learn the secrets about where to buy groceries, how to get around and much more.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
      35,
      39,
      88,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-533280-68.jpg',
    imageAlt: 'welcome to barcelona private tour with a local',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 66,
    totalRatingTitle: '66 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2 - 6 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 48,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-welcome-tour-private-tour-with-a-local-t79827/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 30 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 48,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 127412,
    title: 'Barcelona: Gaudí eScooter Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-gaud-escooter-tour-t127412/',
    price: {
      original: '€ 65',
      min: '€ 65',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1296246-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1296246-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1296246-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1296246-53.jpg',
    smallDescription: "Follow the tracks of Antoni Gaudí's masterpieces through the city of Barcelona.",
    description: 'Follow the tracks of Antoni Gaudí&#039;s masterpieces through the city of Barcelona.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      109,
      29,
      35,
      39,
      55,
      88,
      93,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1296246-68.jpg',
    imageAlt: 'barcelona gaudí escooter tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.9',
    maxPossibleRating: 5,
    totalRating: 9,
    totalRatingTitle: '9 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '2.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 49,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-gaud-escooter-tour-t127412/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 65 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 49,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 36647,
    title: 'Barcelona Tapas Experience',
    url: 'https://www.getyourguide.com/barcelona-l45/tapas-tour-of-barcelona-t36647/',
    price: {
      original: '€ 20',
      min: '€ 20',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2329655-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2329655-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2329655-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-2329655-53.jpg',
    smallDescription: 'Explore the tapas scene of Barcelona on a 3-hour guided tour and sample some of the city’s best tapas at local bars. Discover the secrets of Spanish…',
    description: 'Explore the tapas scene of Barcelona on a 3-hour guided tour and sample some of the city’s best tapas at local bars. Discover the secrets of Spanish gastronomy, with tastings of typical tapas, such as chorizo criollo, patatas bravas and more.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-2329655-68.jpg',
    imageAlt: 'barcelona tapas experience',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 161,
    totalRatingTitle: '161 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 50,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/tapas-tour-of-barcelona-t36647/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 06/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 20 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 50,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 297915,
    title: 'From Barcelona: Montserrat Tour with Guide',
    url: 'https://www.getyourguide.com/montserrat-monastery-l3030/from-barcelona-montserrat-tour-with-guide-t297915/',
    price: {
      original: '€ 42.50',
      min: '€ 42.50',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3318329-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3318329-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3318329-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3318329-53.jpg',
    smallDescription: "Head out of the city and explore the magic of the world famous mountain range of Montserrat. Discover the history, marvel at it's beautiful views and…",
    description: 'Head out of the city and explore the magic of the world famous mountain range of Montserrat. Discover the history, marvel at it&#039;s beautiful views and escape to nature.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3318329-68.jpg',
    imageAlt: 'from barcelona montserrat tour with guide',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.4',
    maxPossibleRating: 5,
    totalRating: 36,
    totalRatingTitle: '36 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.4 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '6 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 51,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/montserrat-monastery-l3030/from-barcelona-montserrat-tour-with-guide-t297915/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 43 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 51,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 195065,
    title: 'Sagrada Familia: Skip-the-Line Guided Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/sagrada-familia-skip-the-line-guided-tour-t195065/',
    price: {
      original: '€ 54',
      min: '€ 54',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1451489-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1451489-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1451489-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1451489-53.jpg',
    smallDescription: 'Skip the lines to the most visited monument in Spain and enjoy a tour of the masterpiece of Antoni Gaudí on this 1.5-hour walking tour.',
    description: 'Skip the lines to the most visited monument in Spain and enjoy a tour of the masterpiece of Antoni Gaudí on this 1.5-hour walking tour.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      29,
      109,
      35,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1451489-68.jpg',
    imageAlt: 'sagrada familia skiptheline guided tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 365,
    totalRatingTitle: '365 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '75 minutes - 1.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 52,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/sagrada-familia-skip-the-line-guided-tour-t195065/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 09/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 54 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 52,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 240482,
    title: 'Flamenco Barcelona SL: Zone A Tickets with A Drink',
    url: 'https://www.getyourguide.com/flamenco-barcelona-sl-l111387/front-row-ticket-to-flamenco-show-t240482/',
    price: {
      original: '€ 35',
      min: '€ 35',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1860372-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1860372-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1860372-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1860372-53.jpg',
    smallDescription: 'Experience a flamenco show in Barcelona at the City Hall Theatre. This marvelous show is composed of a complete repertoire of the best flamenco…',
    description: 'Experience a flamenco show in Barcelona at the City Hall Theatre. This marvelous show is composed of a complete repertoire of the best flamenco artists in Spain performing on the 19th-century stage found in a modern and sophisticated theater.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1860372-68.jpg',
    imageAlt: 'flamenco barcelona sl zone a tickets with a drink',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.5',
    maxPossibleRating: 5,
    totalRating: 15,
    totalRatingTitle: '15 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.5 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 53,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/flamenco-barcelona-sl-l111387/front-row-ticket-to-flamenco-show-t240482/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available from 07/01/2020',
    cardBannerType: 'neutral',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 35 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 53,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 50173,
    title: 'Barcelona: 1-Hour Sightseeing Segway Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-1-hour-sightseeing-segway-tour-t50173/',
    price: {
      original: '€ 34.50',
      min: '€ 27.60',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520969-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520969-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520969-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-520969-53.jpg',
    smallDescription: 'Segway the bike paths and seafront promenades of Barcelona on a 1-hour sightseeing tour, and discover traditional beaches, urban art, and the narrow…',
    description: 'Segway the bike paths and seafront promenades of Barcelona on a 1-hour sightseeing tour, and discover traditional beaches, urban art, and the narrow streets of the Gothic Quarter. Get a panoramic view of the coast from the terrace of Port Olympic.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      35,
      39,
      93,
      88,
    ],
    hasDeal: true,
    dealMaxPercentage: 20,
    isBoostedNewTour: false,
    hasBanner: true,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-520969-68.jpg',
    imageAlt: 'barcelona 1hour sightseeing segway tour',
    isFreeCancellation: false,
    hasRating: true,
    averageRating: '4.9',
    maxPossibleRating: 5,
    totalRating: 135,
    totalRatingTitle: '135 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.9 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '1 hour',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 54,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-1-hour-sightseeing-segway-tour-t50173/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 22 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 54,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 58190,
    title: 'Park Güell Fast-Track Tour',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-early-access-to-gueell-park-t58190/',
    price: {
      original: '€ 24',
      min: '€ 24',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1085058-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1085058-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1085058-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1085058-53.jpg',
    smallDescription: 'Get a fast track at Antoni Gaudi’s fabulous Parc Güell with this tour, and see one of Barcelona’s most whimsical park. Learn the history of Gaudi’s…',
    description: 'Get a fast track at Antoni Gaudi’s fabulous Parc Güell with this tour, and see one of Barcelona’s most whimsical park. Learn the history of Gaudi’s creation, and the art movement that spread across Europe.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1085058-68.jpg',
    imageAlt: 'park güell fasttrack tour',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '3.7',
    maxPossibleRating: 5,
    totalRating: 67,
    totalRatingTitle: '67 Reviews',
    averageRatingClass: '35',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 3.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '75 minutes',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 55,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-early-access-to-gueell-park-t58190/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 24 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 55,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 94605,
    title: 'Barcelona: Wine, Cava, Tapas &amp; Vineyards 4WD Experience',
    url: 'https://www.getyourguide.com/barcelona-l45/exclusive-local-cava-and-wine-tasting-at-family-run-winery-t94605/',
    price: {
      original: '€ 79.99',
      min: '€ 79.99',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-804648-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-804648-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-804648-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-804648-53.jpg',
    smallDescription: 'Enjoy a day trip to 2 family wineries and taste tapas, 4 excellent wines and 4 types of cava, each paired with gourmet delights. A 4x4 drive takes…',
    description: 'Enjoy a day trip to 2 family wineries and taste tapas, 4 excellent wines and 4 types of cava, each paired with gourmet delights. A 4x4 drive takes you through 2,000 year-old vines in the company of a local viticulturist.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-804648-68.jpg',
    imageAlt: 'barcelona wine cava tapas vineyards 4wd experience',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.8',
    maxPossibleRating: 5,
    totalRating: 223,
    totalRatingTitle: '223 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.8 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '6 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 56,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/exclusive-local-cava-and-wine-tasting-at-family-run-winery-t94605/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 80 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 56,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 180968,
    title: 'From Barcelona: Transfer to Montserrat Monastery',
    url: 'https://www.getyourguide.com/barcelona-l45/from-barcelona-transfer-to-montserrat-monastery-t180968/',
    price: {
      original: '€ 30',
      min: '€ 30',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1321550-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1321550-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1321550-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-1321550-53.jpg',
    smallDescription: 'Visit the mountain of Montserrat from Barcelona in a comfortable and air-conditioned vehicle with this low cost option. See the basilica of the…',
    description: 'Visit the mountain of Montserrat from Barcelona in a comfortable and air-conditioned vehicle with this low cost option. See the basilica of the monastery, and choose to visit the museum, or take some of the breathtaking walks to different viewpoints.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: true,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-1321550-68.jpg',
    imageAlt: 'from barcelona transfer to montserrat monastery',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.6',
    maxPossibleRating: 5,
    totalRating: 104,
    totalRatingTitle: '104 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.6 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 57,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/from-barcelona-transfer-to-montserrat-monastery-t180968/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: '15 spots available tomorrow',
    cardBannerType: 'urgent',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 30 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 57,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 56753,
    title: 'Barcelona: 3-Hour Bike Tour with Guide',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-4-hours-bike-tour-t56753/',
    price: {
      original: '€ 24',
      min: '€ 24',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-458485-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-458485-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-458485-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-458485-53.jpg',
    smallDescription: 'Enjoy a Bike tour with a private guide that takes you through Barcelona. Visit the most important places in Barcelona city. Cycle through the Gothic…',
    description: 'Enjoy a Bike tour with a private guide that takes you through Barcelona. Visit the most important places in Barcelona city. Cycle through the Gothic Quarter and take in some of the most iconic monuments by Gaudí.',
    isBestseller: false,
    isFeatured: false,
    languageIds: [
      109,
      29,
      22,
      35,
      55,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-458485-68.jpg',
    imageAlt: 'barcelona 3hour bike tour with guide',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '4.7',
    maxPossibleRating: 5,
    totalRating: 85,
    totalRatingTitle: '85 Reviews',
    averageRatingClass: '45',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 4.7 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 58,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-4-hours-bike-tour-t56753/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: '15 spots available tomorrow',
    cardBannerType: 'urgent',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 24 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 58,
    highlightedOrientation: 'horizontal',
  },
  {
    tourId: 220164,
    title: 'Barcelona: Sangria and Tapas Cooking Workshop with Drinks',
    url: 'https://www.getyourguide.com/barcelona-l45/barcelona-cooking-show-vanguardist-tapas-dinner-cocktail-t220164/',
    price: {
      original: '€ 68.99',
      min: '€ 68.99',
      type: 'individual',
    },
    horizontalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3299084-68.jpg',
    verticalImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3299084-92.jpg',
    mobileImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3299084-53.jpg',
    horizontalSlimImageUrl: 'https://cdn.getyourguide.com/img/tour_img-3299084-53.jpg',
    smallDescription: 'Watch and learn how to cook Tapas with an expert local chef in an evening that offers something for everyone. With this show cooking experience, you…',
    description: 'Watch and learn how to cook Tapas with an expert local chef in an evening that offers something for everyone. With this show cooking experience, you are paired with a well-known chef specializing in Catalan and Spanish cuisine.',
    isBestseller: false,
    isFeatured: true,
    languageIds: [
      109,
      29,
    ],
    hasDeal: false,
    dealMaxPercentage: 0,
    isBoostedNewTour: false,
    hasBanner: false,
    hasRibbon: false,
    priceTag: true,
    detailsLink: false,
    isCertifiedPartner: false,
    isEcoCertified: false,
    isFirstTicket: false,
    isAuthorizedReseller: false,
    isGygOriginal: false,
    imageUrl: 'https://cdn.getyourguide.com/img/tour_img-3299084-68.jpg',
    imageAlt: 'barcelona sangria and tapas cooking workshop with drinks',
    isFreeCancellation: true,
    hasRating: true,
    averageRating: '5.0',
    maxPossibleRating: 5,
    totalRating: 15,
    totalRatingTitle: '15 Reviews',
    averageRatingClass: '50',
    ratingLink: '',
    ratingStyleModifier: '',
    ratingStarsClasses: '',
    ratingTitle: 'Rating: 5.0 out of 5',
    hasDuration: true,
    useValidity: false,
    duration: '3.5 hours',
    validFrom: null,
    displayAbstract: true,
    displayDuration: true,
    displayDate: false,
    displayWishlist: true,
    isWishlistAccountWallEnabled: true,
    displayRemoveButton: false,
    extraBadges: [],
    referrerViewPosition: 59,
    hasDiscountedRecommendation: false,
    urlDetailsBtn: 'https://www.getyourguide.com/barcelona-l45/barcelona-cooking-show-vanguardist-tapas-dinner-cocktail-t220164/?hcm=1',
    hideImage: false,
    isLikelyToSellOut: false,
    cardBannerMessage: 'Available tomorrow',
    cardBannerType: 'positive',
    isPromoted: false,
    isElevated: false,
    showSkywards: false,
    skywardsMiles: 'Earn 69 Miles',
    assetsPath: 'https://cdn.getyourguide.com/assets/d8f31e456e14/customer/desktop/',
    isSpecialOffer: false,
    collectionIdentifier: '',
    experiments: {
      hasOriginalsMoneyBackLabel: true,
    },
    id: 'searchResults',
    activityCardVersion: 'horizontal',
    limit: false,
    isLoggedIn: false,
    timeSlotsExperimentEnabled: false,
    freeCancellationFlag: true,
    resultSetPosition: 59,
    highlightedOrientation: 'horizontal',
  },
];
